import Tags from '@/components/analytics/default_tags.js';
// import XLSX 	from 'xlsx'
// import { utils, writeFile } from 'xlsx';

const ExcelJS = require('exceljs');
import formatSmartEvent from '@/class/formats/SmartEventFormat.js'

class Format {
	constructor(URLs, ML, Moments, Lists = {}, store, debug = false, helper, axios, api) {
		this.URL = URLs.url;
		this.URL_face = URLs.face;
		this.API = api;
		this.List = Lists;
		this.ml = ML;
		this.momentz = Moments.momentz;
		this.moment = Moments.moment;
		this.WS = null;
		this.EventBus = null;
		this.devices = {};
		this.EXT = URLs.ext;
		this.confidence = 0.1;
		this.time_guess = Moments.momentz.tz.guess();
		this.debug = debug;
		this.list_no_devs = ['network', 'pc'];
		this.list_users = null;
		this.Helper = helper;
		this.store = store;
		this.axios = axios;
		this.list_traineds = [];
		this.list_lists = [];
		this.workstations = [];
		this.PARAMETERS = {};
		this.connections = {};
		this.disks = [];
		this.disk = {
			media: "",
			evidences: ""
		}
		// Lazy loading for XLSX to prevent window.cptable from loading until needed
		this.xlsxUtils = null;
		this.xlsxWriteFile = null;
		this.xlsxLoaded = false;

		if (localStorage.getItem('time_zone')) {
			this.timezone = JSON.parse(localStorage.getItem('time_zone'));
		}
		// console.log('time guess : ', this.time_guess)
		let vm = this;
		this.get_disks();
		this.get_traineds();
		this.get_lists();
		// console.log("++++++++++++++++++++++++++++++ store format",store.getters["Devices/list"])


	}

	// Lazy load XLSX only when needed
	async loadXLSX() {
		if (!this.xlsxLoaded) {
			try {
				const xlsx = await import('xlsx');
				this.xlsxUtils = xlsx.utils;
				this.xlsxWriteFile = xlsx.writeFile;
				this.xlsxLoaded = true;
				console.log('XLSX loaded successfully');
			} catch (error) {
				console.error('Error loading XLSX:', error);
				throw error;
			}
		}
		return { utils: this.xlsxUtils, writeFile: this.xlsxWriteFile };
	}

	update_list(key, item) {


		if (key == 'devices') {
			let vm = this
			let list = [...item];
			if (list && list.length > 0) {
				list.forEach((dev) => {
					if (dev && dev.deviceId) {
						vm.devices[dev.deviceId] = dev;
					}
				})
			}
		} else {
			this[key] = item;
		}
	}

	get_list(key) {
		if (key && this[key]) {
			return this[key];
		}
	}

	get_to_lists(key, item, key_field = "id") {
		if (key && this[key] && this[key].length) {
			let idx = this[key].findIndex(x => (x && x[key_field] == item[key_field]));
			if (idx >= 0) {
				return this[key][idx];
			}
			return null;
		} else {
			console.warn("Not exist item for get format list ");
		}
	}

	get_parameters() {
		return this.PARAMETERS;
	}

	add_to_lists(key, item) {
		if (key && this[key] && this[key].length) {
			this[key].unshift(item);
		} else {
			console.warn("Not exist item for add format list ");
		}
	}
	update_to_lists(key, item, key_field = "id") {
		if (key && this[key] && this[key].length) {

			let idx = this[key].findIndex(x => (x && x[key_field] && x[key_field] == item[key_field]));
			if (idx >= 0) {
				this[key][idx] = item;
			}
		} else {
			console.warn("Not exist item for update format list ");
		}
	}

	delete_to_lists(key, item, key_field = "id") {
		if (key && this[key] && this[key].length) {
			let idx = this[key].findIndex(x => (x && x[key_field] == item[key_field]));
			if (idx >= 0) {
				this[key].splice(idx, 1);
			}
		} else {
			console.warn("Not exist item for delete format list ");
		}
	}

	filter_search(search, list, key_field = "name") {

		if (list && list.length > 0) {

			if (search) {
				let filter = list.filter(x => (x && x[key_field] && x[key_field].toLowerCase().indexOf(search.toLowerCase()) > -1)) // includesZ	
				// console.log("FILTER ", filter)	
				if (filter && filter.length > 0) {
					if (key_field) {
						filter.sort((a, b) => {

							if (a && b) {
								if (search && search.length === 1) {
									if (a[key_field].toLowerCase()[0] == search) {
										return -1;
									} else if (b[key_field].toLowerCase()[0] == search) {
										return 1
									}
									return 0
								}

								if (a[key_field].toLowerCase() < b[key_field].toLowerCase()) {
									return -1;
								}
								if (a[key_field].toLowerCase() > b[key_field].toLowerCase()) {
									return 1;
								}
							}
							return 0;
						});

					}
					return filter;
				} else {
					return []
				}
			}
		}
	}
	async search_request(search, list, key_field = "name", request, loading = false) {
		if (list && list.length) {
			if (search) {
				// console.log("REQUEST search 2 ", request);
				if (request) {
					let { type, url, not_limit } = request;
					loading = true;

					return await this.axios[type](this.URL + url, {
						[key_field]: search,
						not_limit,
					}).then(res => {

						loading = false;
						if (res && res.data && res.data.rows && res.data.rows.length > 0) {

							return res.data.rows;
						} else {
							return [];

						}
					}).catch(er => {
						loading = false;
						return [];
					})
					// console.log("LIST await ", list)
					// resolv(list);
				}
			}
		}
	}

	get_disks() {
		const api = this.URL + "/api/v1/disks";
		this.axios.get(api).then(res => {
			if (res && res.rows && res.rows.length > 0) {
				this.disks = res.rows;
				res.rows.some((d) => {
					if (d && d.type && d.type.includes("evidences")) {
						this.disk.evidences = d.path;
						return true
					}
				})
			}
		}).catch(er => {
			console.warn("error get disks ", er);
		})
	}

	get_traineds() {
		const api = this.URL + "/api/v1/face/trained/all";
		this.axios.get(api).then(res => {
			if (res && res.data && res.data.rows && res.data.rows.length > 0) {
				res.data.rows.forEach((it) => {
					if (it) {
						if (it.face_trained && it.face_trained.length > 0 && it.face_trained[0] && it.face_trained[0].face_cropping && it.face_trained[0].face_cropping.url) {
							it.url_face = this.URL + it.face_trained[0].face_cropping.url;
						} else {
							it.url_face = this.EXT + "/img/no_img_found.png";
						}
						if (it.createdAt) {
							it.date_at = this.format_date(it.createdAt, "createdAt");
						}

					}
				});
				// console.log("CHECK traineds ", res.data.rows)
				this.list_traineds = [...res.data.rows];
			}
		}).catch(er => {
			console.warn("Error get traineds ", er)
		})
	}

	get_lists() {
		const api = this.URL + "/api/v1/list/all";
		this.axios.get(api).then(res => {
			if (res && res.data && res.data.rows && res.data.rows.length > 0) {
				this.list_lists = [...res.data.rows];
			}
		}).catch(er => {
			console.warn("Error get traineds ", er)
		})
	}

	get_name_workstation_by_manager_id(manager) {
		if (this.workstations && this.workstations.length > 0) {
			const idx = this.workstations.findIndex((x) => (x && x.manager_id == manager));
			if (idx >= 0) {
				return this.workstations[idx].name;
			}
		} else {
			this.workstations = this.store.getters["Workspaces/list_options"];
			if (this.workstations && this.workstations.length > 0) {
				const idx = this.workstations.findIndex((x) => (x && x.manager_id == manager));
				if (idx >= 0) {
					return this.workstations[idx].name;
				}
			}
		}
		return this.ml.get('n_a');

	}

	connect_to_ws_imgs({ item, imgs, is_selection }, res) {
		if (item && item.tracker_id) {
			let connection = "face_cropping" + item.tracker_id;
			if (this.EventBus) {
				if (this.connections && !this.connections[connection]) {
					/*	this.EventBus.$emit("connection_sq",{
							"connection" : "data",
							"channel" 	 : connection
						})				*/
					let check = false;
					// console.log(" this.connections[connection]  ",  this.connections)
					this.EventBus.$on(connection, this.connections[connection] = (content) => {
						// console.log("test add to ", item.id , is_modal)
						if (content) {
							if (content.status != 2) {
								let params = {
									id: content.id,
									img: this.URL + content.url,//"/face/2022/8/18/1660852267239/1660852266917_i0z6L_3_cutted_face_photo.jpg",
									col: 2,
									height_card: 70,
									height: true ? "75%" : "100%",
									is_selection,
									bbox: null,
									class: "pa-0",
									probability: true ? parseInt(parseFloat(content.prob) * 100) + '%' : "",
								}
								check = true;
								imgs.push(params)
							} else {
								this.EventBus.$off(connection, this.connections[connection]);
								if (this.connections && this.connections[connection]) {
									delete this.connections[connection];
								}
								/*this.EventBus.$emit("connection_sq",{
								"connection" 	: "data",
								"channel" 	 	: connection,
								"close_channel" : true,
							});			*/
							}
						}
					})
					const timer = setTimeout(() => {
						if (!check) {
							this.EventBus.$off(connection, this.connections[connection]);
							if (this.connections && this.connections[connection]) {
								delete this.connections[connection];
							}
							// this.connections[connection] = null;
							/*this.EventBus.$emit("connection_sq",{
							"connection" 	: "data",
							"channel" 	 	: connection,
							"close_channel" : true,
						});*/
						}
						clearTimeout(timer);
					}, 20000)

				}

			}
		}
	}

	currentDateGuess() {
		return this.momentz(this.momentz.now()).tz(this.time_guess).format('ll, LTS')
	}

	format_date(item, parse_format = 'timestamp', formate = 'll, LTS') { // 
		let date_format = null;
		if (item) {

			if (parse_format == 'timestamp') {
				const ms = this.normalizeTimestampFieldToMs(item);
				if (ms != null) {
					date_format = this.momentz(ms).format(formate);
				}
			} // timestamp
			else if (parse_format == 'createdAt') {
				date_format = this.momentz(item).format(formate);
			}// createdAt

		} // item
		return date_format;
	} // format date

	/**
	 * Pasa un número (segundos, ms o µs mal escalados) a ms Unix válidos para eventos.
	 * Evita años imposibles (p. ej. 581xx) cuando el backend manda µs o mezcla unidades.
	 */
	coerceUnixNumberToMs(n) {
		if (!Number.isFinite(n) || n <= 0) return null;
		let x = n;
		while (x > 1e14) {
			x = Math.floor(x / 1000);
		}
		if (x < 1e11) {
			x = Math.round(x * 1000);
		}
		const y = this.momentz(x).year();
		if (y < 1980 || y > 2110) return null;
		return Math.round(x);
	}

	/** Misma lógica que format_date modo timestamp + strings ISO / solo dígitos */
	normalizeTimestampFieldToMs(val) {
		if (val == null || val === '') return null;
		if (typeof val === 'string') {
			const t = val.trim();
			if (!t) return null;
			if (/^\d+$/.test(t)) {
				let len = t.length;
				let n = parseInt(t, 10);
				if (len === 16) {
					n = Math.floor(n / 1000);
				}
				return this.coerceUnixNumberToMs(n);
			}
			const m = this.momentz(t);
			return m.isValid() ? m.valueOf() : null;
		}
		if (typeof val === 'number' && Number.isFinite(val)) {
			let n = val;
			const len = String(Math.trunc(Math.abs(n))).length;
			if (len === 16) {
				n = Math.floor(n / 1000);
			}
			return this.coerceUnixNumberToMs(n);
		}
		const m = this.momentz(val);
		return m.isValid() ? m.valueOf() : null;
	}

	/**
	 * Precedencia alineada con check_date: timestamp → unix_itme_stamp → createdAt → vinfo.*
	 * Uso: feed mixto y cualquier vista que necesite ms canónicos sin re-parsear `ll, LTS`.
	 */
	itemTimestampToMs(item) {
		if (!item) return null;
		let vinfo = null;
		if (item.vinfo && typeof item.vinfo === 'string') {
			try {
				const parsed = JSON.parse(item.vinfo);
				if (parsed && typeof parsed === 'object') vinfo = parsed;
			} catch (e) {
				/* ignore */
			}
		}
		const tryField = (v) => {
			const ms = this.normalizeTimestampFieldToMs(v);
			return ms != null && Number.isFinite(ms) ? ms : null;
		};
		if (item.timestamp != null && item.timestamp !== '') {
			const ms = tryField(item.timestamp);
			if (ms != null) return ms;
		}
		if (item.unix_itme_stamp != null && item.unix_itme_stamp !== '') {
			const ms = tryField(item.unix_itme_stamp);
			if (ms != null) return ms;
		}
		if (item.createdAt != null && item.createdAt !== '') {
			const ms = tryField(item.createdAt);
			if (ms != null) return ms;
		}
		if (vinfo) {
			if (vinfo.unix_itme_stamp != null && vinfo.unix_itme_stamp !== '') {
				const ms = tryField(vinfo.unix_itme_stamp);
				if (ms != null) return ms;
			}
			if (vinfo.createdAt != null && vinfo.createdAt !== '') {
				const ms = tryField(vinfo.createdAt);
				if (ms != null) return ms;
			}
			if (vinfo.date != null && vinfo.date !== '') {
				const ms = tryField(vinfo.date);
				if (ms != null) return ms;
			}
		}
		return null;
	}

	// for convert date to send back, 
	format_date_time(dates, picker, guess, hrs = true) {
		let tz_guess = guess ? this.time_guess : this.timezone;
		let date1 = guess ? this.momentz(this.momentz.now()).tz(tz_guess).format('YYYY-MM-DD') : this.momentz(this.momentz.now()).format('YYYY-MM-DD'), // L
			date2 = date1;

		// console.log(this.momentz(this.momentz.now()).tz(this.time_guess).format('YYYY-MM-DD'), "gues time format" )
		if (dates && dates.length > 0) {
			dates.sort(function (a, b) {
				// Turn your strings into dates, and then subtract them
				// to get a value that is either negative, positive, or zero.
				return new Date(a) - new Date(b);
			});
			// Convertir Date objects a strings si es necesario
			const processedDates = dates.map(date => {
				if (date instanceof Date) {
					return this.momentz(date).format('YYYY-MM-DD');
				}
				return date;
			});

			// console.log("BEFORE FORMAT :  ", processedDates)

			date1 = processedDates[0];
			if (dates && dates[1]) {
				date2 = processedDates[1]; //  date2 = dates[1].replaceAll(/-/ig, '/');
			} else {
				date2 = processedDates[0];
			}


		} else {
			dates = [];
			dates[0] = this.momentz(date1).tz(tz_guess).format('YYYY-MM-DD');
			dates[1] = dates[0]
		}

		if (picker) {
			if (picker.start) {
				date1 += ' ' + picker.start;
			} else {
				date1 += " " + "00:00";
			}
			if (picker.end) {
				date2 += ' ' + picker.end;
			} else {
				date2 += " " + "23:59";

			}
		} else {
			date1 += " " + "00:00";
			date2 += " " + "23:59";
		}

		/*	let start_unix = 
			let end_unix   = this.moment.unix()*/
		if (this.debug && this.debug.logs) {

			console.log("time ",
				"\n 2 ", this.moment(new Date(date2)),
				"\n 1 ", this.moment(new Date(date1)),
				"\n diff ", this.moment.duration(this.moment(date2).diff(this.moment(date1))).asHours()
			);
			// console.log("times : ",  this.moment.duration(date2.diff(date1)));
		}
		if (this.moment.duration(this.moment(date2).diff(this.moment(date1))).asHours() > 24 && hrs) {
			return "required_range_24h";
		}
		// console.log("**************************** tz ", date1, date2, tz_guess)
		date1 = this.momentz(date1).tz(tz_guess).format('YYYY/MM/DD_HH-mm-ss');
		date2 = this.momentz(date2).tz(tz_guess).format('YYYY/MM/DD_HH-mm-ss');

		return {
			start: date1,
			end: date2
		};
	}
	diffHours(start, end, timezone) {
		let dateStart = this.momentz.tz(start, timeZone)
		let dateEnd = this.momentz.tz(end, timeZone)
		return dateEnd.diff(dateStart, 'hours')
	}
	diffDurationHours(date, date2) {
		return this.moment.duration(this.moment(date).diff(this.moment(date2))).asHours()
	}
	// playback , menus / for convert format in selector dates
	format_date_picker(dates = [], guess = true) {
		let date1 = guess && this.time_guess ?
			this.momentz(this.momentz.now()).tz(this.time_guess).format('YYYY-MM-DD') :
			this.momentz(this.momentz.now()).format('YYYY-MM-DD'); // L / YYYY/MM/DD
		// date2 = date1;
		// console.log("check format dete picker : ", date1)
		if (dates && dates.length > 0) {
			if (dates[0] == 'Invalid date') {
				dates[0] = date1; //this.momentz(date1).format('YYYY-MM-DD');
			} else {
				dates[0] = this.momentz(dates[0]).format('YYYY-MM-DD');
			}

			if (dates[1] == 'Invalid date') {
				dates[1] = dates[0]; //this.momentz(dates[0]).format('YYYY-MM-DD');	
			} else {
				dates[1] = this.momentz(dates[1]).format('YYYY-MM-DD');
			}
		} else {
			// console.log("GUESS ; ", this.time_guess, date1)
			dates = [];
			dates[0] = date1;//this.momentz(date1).format('YYYY-MM-DD');
			dates[1] = dates[0]
		}
		return dates;

	}

	format_UTC(date, guess) {
		if (!date) {
			let date1 = guess && this.time_guess ? this.momentz(date).tz(this.time_guess) : date;
			let utc = this.moment.utc(date1);
			// console.log("check dates, origin ", date, " ?  \n guess", date, ' \n utc : ', utc)
			return utc;
		}
		return date
	} // format utc

	format_date_to_dates_seg(date, sum, opt) { // , datee | just to convert date to dates with other time sum +-
		// console.log("DATE format  : ", date,  this.momentz(date).format("YYYY/MM/DD_HH-mm-ss"), " | guess " + this.momentz(date).tz(this.time_guess).format("YYYY/MM/DD_HH-mm-ss"));
		// console.log("date DATE format 1 : ", datee, this.momentz(datee).format("YYYY/MM/DD_HH-mm-ss"), " | guess " + this.momentz(datee).tz(this.time_guess).format("YYYY/MM/DD_HH-mm-ss"));

		let dt = this.moment(date).valueOf(); // new Date (date);		
		let dt_seg = null;
		// let test  	= null 
		// let t  		= this.moment(datee).valueOf();
		if (opt == "subtract") {
			dt_seg = dt - sum;
			// test   = t - sum
		} else {
			dt_seg = dt + sum;
		}
		let date1 = this.momentz(dt).tz(this.time_guess).format("YYYY/MM/DD_HH-mm-ss");
		let date2 = this.momentz(dt_seg).tz(this.time_guess).format("YYYY/MM/DD_HH-mm-ss");
		// let date1 = this.moment.utc(dt).format();
		// let date2 = this.moment.utc(dt_seg).format();
		// console.log("DATE Format : ", dt/*dt.getTime(), dt.getTime() - 30000,*/ , this.time_guess );
		// console.log("DATE diff : ", this.momentz(dt).format("YYYY/MM/DD_HH-mm-ss") , " | guess " + this.momentz(dt).tz(this.time_guess).format("YYYY/MM/DD_HH-mm-ss"))
		// console.log("date DATE diff  1: ", t , this.momentz(t).format("YYYY/MM/DD_HH-mm-ss") , " | guess " + this.momentz(t).tz(this.time_guess).format("YYYY/MM/DD_HH-mm-ss"))		
		// console.log("date test DATE diff  2: ", test , this.momentz(test).format("YYYY/MM/DD_HH-mm-ss") , " | guess " + this.momentz(test).tz(this.time_guess).format("YYYY/MM/DD_HH-mm-ss"))

		return [
			date2,
			date1,
		]
	}



	format_parse_json(item) {
		let info_parse = null;
		try {
			let cont = 0;
			while (typeof info_parse == 'string' && info_parse && cont < 5) {
				info_parse = JSON.parse(info_parse);
				cont++;
			}
		} catch (e) {
			info_parse = null;
		}

		return info_parse;

	} // format_parse_json

	format_price(price) {
		return (price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
	}

	format_content(item, item_info, list, type) {
		if (type == 'array') {
			if (list && list.length > 0) {
				list.forEach((item_list) => {
					if (item_list && item_info[item_list]) {
						item[item_list] = item_info[item_list];
					}
				});
			}
		}
		return item;
	} // format_content

	render_device(val) {
		// if (this.devices && this.devices.length > 0) {
		let vm = this,
			device = '';

		if (this.devices && this.devices[val] && this.devices[val].deviceId == val) { // 

			// const find = vm.devices.some( function (dev, idx_dev){

			device = this.devices[val];
			// return true

			// }) 

			return device;
		}

		// }
		return '';
	} // render_device

	render_lists(val) {
		if (this.list_lists && this.list_lists.length > 0) {
			const idxLists = this.list_lists.findIndex(x => x && x.id == val);
			if (idxLists > -1) {
				return this.list_lists[idxLists];
			}
		}
		return null
	}

	render_traineds(val) {
		if (this.list_traineds && this.list_traineds.length > 0) {
			const idxTrained = this.list_traineds.findIndex(x => x && x.userId == val);
			if (idxTrained > -1) {
				return this.list_traineds[idxTrained];
			}
		}
		return null
	}

	renderHeadersTable(head) {
		if (head == "lpr") {
			return [
				// {
				// 	text: vm.$ml.get('id'), //Catergory
				//           align: 'center',
				//           sortable: false,
				//           value: 'id',//catergory
				// },
				{ text: 'device', value: 'device' },
				{ text: 'plate', value: 'plate_chars' },
				{ text: 'segment', value: 'img', align: 'center', icon: "mdi-cursor-default-click" },
				// { text: 'Plate', 			value: 'plate' },
				// { text: 'Manager', 			value: 'manager' },
				{ text: 'date', value: 'date' },

			]; //headers
		} else

			if (head == "alerts") {
				return [
					{
						text: 'category', //Catergory
						align: '',
						sortable: false,
						value: 'categorie',//catergory
					},
					{ text: 'device', value: 'device' },
					{ text: 'plate', value: 'plate_chars' },
					// { text: vm.$ml.get('motive'), value: 'motive',
					{ text: 'evidence', value: 'img', icon: "mdi-cursor-default-click" },
					{ text: 'probability', value: 'probability' },
					{ text: 'date', value: 'createdAt' },
				];
			} else
				if (head == "objects" || head == "motion") {
					return [
						{ text: 'device', value: 'device', align: '' },
						{ text: 'tags', value: 'tags_colors', align: '', },
						{ text: 'evidence', value: 'img', align: 'center', icon: "mdi-cursor-default-click" },
						{ text: 'probability', value: 'probability' },
						{ text: 'date', value: 'date', align: '', },
					];

				} else

					if (head == "weapon_detector") {
						return [
							// { text: vm.$ml.get('id'), 	value: 'id', align: 'center' },
							{ text: 'device', value: 'device', align: '' },
							{ text: 'category', value: 'category', align: '' },
							{ text: 'segment', value: 'img', align: '', icon: "mdi-cursor-default-click" },
							{ text: 'date', value: 'date', align: '' },

						];
					} else
						if (head == "alarms" || head == "smart_event") {
							return [
								// { text: vm.$ml.get('id'), 		value : 'id', align: 'center' },
								{ text: 'device', value: 'device', align: '' },
								{ text: 'tag', value: 'tags_colors', align: '' },
								{ text: 'evidence', value: 'img', align: '', icon: "mdi-cursor-default-click" },
								{ text: 'face', value: 'face_detected_url', align: '', icon: "mdi-cursor-default-click" },
								{ text: 'probability', value: 'probability' },
								{ text: 'owner', value: 'owner' },
								// { text : 'detail', value : 'detail' },				

								{ text: 'date', value: 'date', align: '' },
								{ text: 'side', value: 'side', align: '' },
								{ text: 'way', value: 'way', align: '' },
								{ text: 'type_incident', value: 'type_incident', align: '' },

								// { text : vm.$ml.get('is_incident'), value : 'is_incident', align: '' },						
								// { text : vm.$ml.get('confirmed_alert'), value : 'is_confirmed', align: '' },
								{ text: 'user', value: 'user', align: '' },
								{ text: 'action', value: 'action_done', align: '' },
								{ text: 'confirmed_date', value: 'date1', align: '' },
								// { text : vm.$ml.get('isignored'), 			value : 'isignored', align: '' },
								// { text : vm.$ml.get('false_positive'), 	value : 'false_positive', align: '' },						


							];
						} else

							if (head == 'actions') {
								return [
									// { text: vm.$ml.get('id'), 	value: 'id', align: 'center' },
									{ text: 'device', value: 'device', align: '' },
									{ text: 'tags', value: 'tags_colors', align: '' },
									{ text: 'evidence', value: 'img', align: '', icon: "mdi-cursor-default-click" },
									{ text: 'probability', value: 'probability' },
									{ text: 'date', value: 'date', align: '' },

								];
							} else

								if (head == 'technical') {
									return [
										{ text: "state", value: "img_tech", align: 'center' },
										{ text: "device", value: "device" },
										{ text: "computer", value: "computer" },
										{ text: "detail", value: "tag" },
										// { text : vm.$ml.get("code"), value : "code" },
										// { text : vm.$ml.get("module"), value : "module" },
										// { text : vm.$ml.get("type"), value : "type" },
										{ text: "date", value: "date" },
									];
								} else
									if (head == 'reports') {
										return [
											// { text : vm.$ml.get("state"), value : "img_tech", align : 'center' },
											{ text: "device", value: "device" },
											{ text: 'tags', value: 'tags_colors', align: '' },
											// { text : vm.$ml.get("computer"), value : "computer" },
											// { text : vm.$ml.get("detail"), value : "tag" },
											// { text : vm.$ml.get("code"), value : "code" },
											// { text : vm.$ml.get("module"), value : "module" },
											// { text : vm.$ml.get("type"), value : "type" },
											{ text: "date", value: "date" },
										];
									}
									else
										if (head == "peripherals") {
											return [

												{ text: "name", value: "name" },
												{ text: 'type_peripheral', value: 'tags_colors', align: '' },
												{ text: "detail", value: "detail" },
												{ text: "date", value: "date" },

											];
										} else
											if (head == "incidents") {
												return [
													{ text: "name", value: "name" },
													{ text: "device", value: "device" },
													// { text : vm.$ml.get('type'), 	value: 'type', align: '' },										
													{ text: "state", value: "state" },
													{ text: "date", value: "date" },
												];
											} else
												if (head == "parking") {
													return [
														{ text: "information", value: "information" },
														{ text: "entry", value: "entry" },
														{ text: 'exit', value: 'exit', align: '' },
														{ text: "status", value: "status" },
														{ text: "invoice", value: "invoice" },

													];
												} else
													if (head == "audios") {
														return [
															{ text: "name", value: "name" },
															{ text: "device", value: "device" },
															{ text: 'audio', value: 'audio', align: '' },
															{ text: "duration", value: "duration" },
															{ text: "date", value: "date" },

														];
													} else
														if (head.includes("face")) {
															return [
																{ text: 'device', value: 'device', align: '' },
																{ text: 'tags', value: 'tags_colors', align: '', },
																{ text: 'evidence', value: 'img', align: 'center', icon: "mdi-cursor-default-click" },
																{ text: 'probability', value: 'probability' },
																{ text: 'date', value: 'date', align: '', },
															];

														} else
															if (head == "avc") {
																return [
																	{ text: 'device', value: 'device', align: '' },
																	{ text: 'vehicle_type', value: 'tags_colors', align: '', },
																	{ text: 'axle_counter', value: 'axle_counter' },
																	{ text: 'evidence', value: 'img', align: 'center', icon: "mdi-cursor-default-click" },
																	{ text: 'date', value: 'date', align: '', },
																];
															}
	}


	// ********************************************** CHECKS ***********************************

	check_bbox_tags(item, vinfo, analytic, new_format) {
		let results = null;
		let check_tags = [];
		let tags = [];
		let tag_1 = this.ml.get('not_found_tag');
		let probability_1 = this.ml.get('not_found');
		let is_prob = false;
		let confidence_1 = null;
		let motive_1 = null;
		let duration_1 = null;
		let tag_color = [];
		let valert_1 = null;
		let fieldSpeed = null; //this.ml.get("n_a");
		let alert = {
			isPopup: false,
			isSound: false,
			sound: 'alert',
			color: 'red',
			name: '',
		};
		let name_incidente = this.ml.get('not_found');
		let state_incident = this.ml.get('not_found');
		let tag_audio = this.ml.get("not_found");
		let duration_audio = "00:00:00";
		let axle_counter1 = this.ml.get("not_found");
		let url = this.URL;

		// console.log(item , "****************************")

		if (item.tag) {
			tag_1 = item.tag;
		} else
			if (vinfo && vinfo.tag) {
				tag_1 = vinfo.tag;

			} else if (item.action) {
				tag_1 = item.action;
			} else if (item.channel) {
				tag_1 = item.channel;
			} else if (item.source) {
				tag_1 = item.source;
			} else if (item.rule_access) {
				tag_1 = item.rule_access.access ? 'Access Granted' : 'Access Denied';
			} else if (vinfo && vinfo.rule_access) {
				tag_1 = vinfo.rule_access.access ? 'Access Granted' : 'Access Denied';
			} else if (item.type_peripheral) {
				tag_1 = item._type_peripheral;
			} else if (item.vehicle_type) {
				tag_1 = item.vehicle_type;
			}
			else {
				// tag_1 = analytic;
				if (analytic != "technical") {
					// console.warn("Not found tag of event ", analytic, item);
				}
			}
		// console.log(tag_1 , item, vinfo, " TAG ****************************")

		if (tag_1) {
			let idx = Tags.findIndex(x => (x && x.key == tag_1));
			let color = item.color_tag || 'primary';
			if (idx >= 0) {
				color = Tags[idx].color;
			}
			// face
			tag_1 = tag_1 == 'Access Denied' ? 'face' : tag_1;
			tag_1 = tag_1 == 'tracker' ? 'objects' : tag_1;
			new_format.tag = tag_1;
			tag_color.push({
				tag: tag_1,
				color: color,
				count: 1,
			})
		}


		if (item.name_categorie) {
			item.name_categorie.split(",").forEach((it) => {
				if (it) {
					check_tags.push(it);
					tag_color.push({
						tag: it,
						color: "error",
						count: 1,
					});
					// console.log("temp ", it)
				}
			})
		}

		// =======================================

		if (item.motive_categorie) {
			motive_1 = item.motive_categorie;
		} else {
			if (vinfo && vinfo.motive_categorie) {
				motive_1 = vinfo.motive_categorie;
			}
		}
		if (motive_1) {
			new_format.motive = motive_1;
		}


		// =======================================		
		// probability
		if (item.probability) {
			probability_1 = parseInt(parseFloat(item.probability) * 100) + '%';
			is_prob = true;

		} else if (vinfo && vinfo.probability) {
			probability_1 = parseInt(parseFloat(vinfo.probability) * 100) + '%';
			is_prob = true;

		} else if (item.prob) {
			probability_1 = parseInt(parseFloat(item.prob) * 100) + '%';
			is_prob = true;

		} else if (vinfo && vinfo.prob) {
			probability_1 = parseInt(parseFloat(vinfo.prob) * 100) + '%';
			is_prob = true;

		}

		// =======================================
		if (item.duration) {
			duration_1 = item.duration;
			new_format.duration = duration_1;
		}

		// Alert ========================================

		/*if (item.rule_access  && item.rule_access.active && !item.rule_access.access && parseFloat(item.confidence) >= this.confidence) {
			alert.isPopup = true;	
			alert.sound   = item.rule_access.access ? 'alert_success' : 'alert'		
		}*/

		if (item.isPopup) {
			alert.isPopup = item.isPopup;
		} else {
			if (vinfo && vinfo.isPopup) {
				alert.isPopup = vinfo.isPopup;
			}
		}

		if (item.name) {
			alert.color = item.color
			alert.name = item.name
		} else if (vinfo && vinfo.name) {
			alert.color = vinfo.color
			alert.name = vinfo.nam

		}
		if (item.isSound) {
			alert.isSound = item.isSound;
			alert.sound = item.sound
		} else {
			if (vinfo && vinfo.isSound) {
				alert.isSound = vinfo.isSound;
				alert.sound = vinfo.sound
			}
		}


		if (item.timeout) {
			alert.timeout = item.timeout;
		}
		if (this.PARAMETERS && this.PARAMETERS.timeoutAlert) {
			alert.timeoutAlert = this.PARAMETERS.timeoutAlert;
		}


		// additional info :: content 2
		if (item.valert) {
			valert_1 = item.valert;
		}

		// =======================================
		// face
		if (item.confidence) {
			confidence_1 = parseInt(parseFloat(item.confidence) * 100);

		} else
			if (vinfo && vinfo.confidence) {
				confidence_1 = vinfo.confidence ? parseInt(parseFloat(vinfo.confidence) * 100) : '';
			}
		if (confidence_1) {
			probability_1 = confidence_1 + '%';
			new_format.confidence = probability_1;
			// new_format.probability  = probability_1;
		}
		if (item.prediction) {
			new_format.prediction = item.prediction
		}

		if (item.folder_path) {
			new_format.folder = item.folder_path;
		}

		// =======================================
		// check tags of results 
		if (item.analytics_results) {
			results = item.analytics_results;
		}
		if (!results) {
			if (vinfo && vinfo.analytics_results) {
				results = vinfo.analytics_results;
			}
			/*if (!results) {
				results = item.object && item.object.length > 0 ? item.object : null;
			}*/
		}
		if (analytic == 'actions' && item.actions && !results) {
			results = item.actions;
		}

		if (analytic == "avc") {
			if (item.axle_count) {
				axle_counter1 = item.axle_count;
			}
		}

		if (results && results.length > 0) {
			// console.log("resultssss ***************")
			results.forEach(function (arr_tag, idx_tag) {
				if (arr_tag && (arr_tag.tag || arr_tag.action)) {
					let color = 'primary';
					let temp_tag = arr_tag.tag || arr_tag.action;

					if (temp_tag == 'gun') {
						color = 'error'
					}
					if (arr_tag.prob && !is_prob) {
						let temp_prob = arr_tag.prob;
						probability_1 = parseInt(parseFloat(temp_prob) * 100) + '%';
						is_prob = true;
					}

					if (check_tags.indexOf(temp_tag) >= 0) {
						tags[check_tags.indexOf(temp_tag)].count++;


					} else {

						check_tags.push(temp_tag);
						tags.push({
							tag: temp_tag,
							color: color,
							count: 1,
						})



					}
				}
				//  actions case to check
				/*if (item_act.gifevidence) {
					new_format.images.push({
						img : url + '/' + item_act.gifevidence,
					});
				}*/

			}); // forEach
			new_format.tags = check_tags;
			new_format.bbox = true;


		} else {


			check_tags.push(tag_1);

			tags.push({
				tag: tag_1,
				color: 'primary',
				count: 1,
			});

			new_format.tags = check_tags;
			// console.log("check x y w h  : ", item )
			if (item.bbox) {

				new_format.bbox = true;

				try {
					let temp_bbox = item.bbox
					if (typeof temp_bbox == 'string') {
						temp_bbox = JSON.parse(item.bbox);
					}
					if (typeof temp_bbox == 'string') {
						temp_bbox = JSON.parse(temp_bbox);
					}
					// console.log("RESULT BOX !", typeof temp_bbox)
					temp_bbox.tag = tag_1;
					results = [];
					results.push({ bbox: temp_bbox });
				} catch (er) {
					console.log("Error : ", er);
				}
			} else {
				if (item.x && item.y && item.w && item.h) {
					new_format.bbox = true;
					results = [];
					const { x, y, w, h } = item;
					results.push({
						bbox: {
							x,
							y,
							w,
							h,
							tag: tag_1,
						}
					});

				}
			}
		}
		if (new_format && new_format.tags && new_format.tags.length === 0) {
			new_format.tags.push(tag_1);
		}




		// console.log("probability : ***********************", probability_1)
		if (probability_1) {
			new_format.probability = probability_1;
		}
		if (item.name) {
			name_incidente = item.name;
		}
		if (item.state) {

			state_incident = item.state;
		}
		if (analytic) {
			if (item.plate) {
				new_format.plate_char = item.plate;
			} else if (vinfo && vinfo.plate_chars) {
				new_format.segment = {
					img: url + '/' + vinfo.segment_photo,
					is_segment: true,
					height: '75px',
					title: this.ml.get('segment'),
					fit: 'cover',
					col: 6,
				};

			}
			if (item.barcode) {
				new_format.barcode = item.barcode;

			}
		}
		if (analytic == "objects") {
			let tempVel = "Km/h";
			if (item.speed) {
				fieldSpeed = item.speed + tempVel;
				new_format.speed = item.speed + tempVel;
				// new_format.tags.push(item.speed);
			} else if (vinfo && vinfo.speed) {
				fieldSpeed = vinfo.speed + tempVel;
				new_format.speed = vinfo.speed + tempVel;

				// tags.push({ 
				// 	tag 	: vinfo.speed,  
				// 	color 	: 'primary',
				// 	count 	: 1,
				// });
				// new_format.tags.push(vinfo.speed);
			}
		} else {
			if (item.speed) {
				new_format.speed = item.speed;
			} else if (vinfo && vinfo.speed) {
				new_format.speed = vinfo.speed;
			}
		}
		if (analytic == 'audios') {

			if (item.name) {
				tag_audio = item.name;
			}
			if (item.duration) {
				duration_audio = item.duration;
			}
		}
		if (item.analytic == "lpr") {
			new_format.tag = check_tags;
		}

		// console.log("RESULTS BBOX : ", results, item.bbox);



		return {
			tag_: tag_1,
			tags_color: tags, // array objs
			tag_color, // one tag obj
			format_tags: check_tags, // array 
			bbox: results,
			probability_1,
			confidence_1,
			alert_1: alert,
			valert_1,
			name_incidente,
			state_incident,
			tag_audio,
			duration_audio,
			axle_counter1,
			fieldSpeed,

		}

	} //check_bbox
	check_images(item, vinfo, analytic, new_format, bbox) {
		let url = this.URL;
		let url_face = this.URL_face;
		let ext = this.EXT;
		let img_full = ext + '/img/no_img_found.png';
		let img_segment = img_full;
		let img_thumbnail = ext + '/img/no_img_found.png';
		let is_face = false;
		let is_selection = false;
		let content_img = null;
		let exit_full_photo1 = ext + '/img/no_img_found.png';
		let entry_full_photo1 = ext + '/img/no_img_found.png';
		let imgs = [];
		let audioo = null;
		let style_image = { width: "80px" };
		let height_image = "25px";

		// console.log("bbox : ", bbox)
		//console.log("IMAGE ", item," vin ",vinfo, analytic)
		if (bbox && bbox.length === 0) {
			bbox = null;
		}
		if (item.url_evidence) {
			let image = item.url_evidence;
			if (image.includes("alice-media")) {
				let temp = image.split("alice-media")[1];
				image = temp;
			}
			img_full = url + '/' + image;
			img_segment = url + '/' + image;
			// item.user_trained 	= "bf3d8690-2a36-402d-98d4-635a0d9fed86"

			let check_faces = false;

			let isFaceCropping = false;
			if (analytic.includes("face") || analytic == 'alarms' || analytic == "smart_event") { //  
				let temp_prob = 0;
				let url_prob = "";
				let url_null = null;

				if (item.segment_photo_url) {
					new_format.segment = {
						img: url + '/' + item.segment_photo_url,
						is_segment: true,
						height: '75px',
						title: this.ml.get('segment'),
						fit: 'cover',
						col: 6,
					};
				}
				new_format.images.push({
					img: item.face_detected_url, //url + '/' + (url_prob || url_null),
					title: this.ml.get("face_detected"),
					col: 6,
					height: "100%", // 80
					// bbox : bbox,
				});





				if (item.facecropping && item.facecropping.length > 0) {
					// console.warn("add cropping ")
					is_selection = analytic.includes("face") ? true : false;
					item.facecropping.forEach((img_for, idx_for, len_for) => {
						imgs.push({
							img: url + img_for.url,
							col: 4,
							height_card: 75,
							height: img_for.prob ? "95%" : "100%", // 75
							is_selection,
							// title 	: this.ml.get('evidence'),
							bbox: null,
							class: "pa-0",
							...img_for,
							// title 		: img_for.title ? this.ml.get(img_for.title) : "", 
							probability: img_for.prob ? parseInt(parseFloat(img_for.prob) * 100) + '%' : "",
						});
						if (img_for.prob > temp_prob) {
							url_prob = img_for.url;
							temp_prob = img_for.prob;
						} else {
							if (img_for && !img_for.prob) {
								url_null = img_for.url;
							}
						}
						if (idx_for == (len_for.length - 1)) {
							isFaceCropping = true;
							img_full = url + (url_prob || url_null);
							style_image.width = "80px";
							height_image = "40px";
							check_faces = true;
							new_format.images.push({
								img: img_full, //url + '/' + (url_prob || url_null),
								title: this.ml.get("face_detected"),
								col: 6,
								height: "100%", // 80
								// bbox : bbox,
							});
						}
					})
					is_face = true;
					content_img = [...imgs];
					if (check_faces) {
						this.connect_to_ws_imgs({ item, imgs: content_img, is_selection });
					}

					// new_format.images = new_format.images.concat(imgs);
				}


			}
			// console.log("item.user_trained ", analytic, item.user_trained)
			if (['face', 'smart_event', 'alarms', 'face_detected'].includes(analytic)) {
				let is_trained = false;
				//console.log("TRAINED ", item)
				if (item.user_trained) {
					// let idx = this.list_traineds.findIndex(x => (x && x.userId == item.faceUUID))
					// if (idx >= 0) {
					// item.item_faceUUID 	= this.list_traineds[idx];
					let temp = item.user_trained; //this.list_traineds[idx];
					// console.log("IMG ", temp.face_trained[0].face_cropping)
					if (temp && temp.face_trained && temp.face_trained.length > 0 && temp.face_trained[0] && temp.face_trained[0].face_cropping) {
						new_format.images.push({
							img: url + '/' + temp.face_trained[0].face_cropping.url,
							title: this.ml.get("similar_face"),
							col: 6,
							height: "100%", // 80
							// bbox : bbox,
						});
						is_trained = true;
					}
					// }
				}
				if (!is_trained && isFaceCropping) {				// analytic == "face_detected"
					new_format.images.push({
						img: ext + '/img/tags/no_similarity/no_similarity_1.png',//'/img/no_MatchFace.png',
						title: this.ml.get("no_similarity_found"),
						col: 6,
						height: "90%",
						// bbox : bbox,
					});
				}
			}
			new_format.images.push({
				img: url + '/' + image,
				bbox: bbox,
				col: item.user_trained && check_faces ? 12 : item.user_trained ? 6 : 12,
				height: "100%", // 80
				title: this.ml.get("evidence")
			});
		} else if (item.gifevidence) {
			let temp_gif = item.gifevidence.split('alice-media');
			// console.log("gif 1" , temp_gif[1])
			if (temp_gif && temp_gif.length > 0) {

				img_full = url + '/' + temp_gif[1];
				img_segment = img_full;
			} else {
				// console.log("GIF : ", "/disk-media/disk1t/action_/".split('/disk-media/disk1t'))
				if (this.disk && this.disk.evidences) {

					temp_gif = item.gifevidence.split(this.disk.evidences);
					if (temp_gif && temp_gif.length > 0) {
						// console.log("gif " , temp_gif)
						img_full = url + '/' + temp_gif[1];
						img_segment = img_full;
					}
				}
			}
			new_format.images.push({
				img: img_full,
			});

		} else
			if (item.url_photo_event) {
				let image = item.url_photo_event;
				if (image.includes("alice-media")) {
					let temp = image.split("alice-media")[1];
					image = temp;
				}
				img_full = url + image;
				new_format.images.push({
					img: img_full,
					bbox: bbox,

				});
			} else
				if ((item || vinfo) && (analytic.includes('face') || analytic == 'alarms')) {
					// let imgs 		  		= [];
					let idx_evidence = null;
					let check_imgs = 0;
					let url_temp = analytic.includes('face') ? url_face : url;
					// console.log("TRAINED 2 ", item , " vin ", vinfo)
					//face
					if (item.fullimg || (vinfo && vinfo.fullimg)) {
						let vfull = vinfo && vinfo.fullimg ? vinfo.fullimg : '';
						let temp_full = item.fullimg || vinfo.fullimg;
						img_full = url_temp + temp_full;
						// console.log( "FULL IMG ", img_full)
						if (img_full) {
							imgs.push({
								img: img_full,
								title: this.ml.get('evidence'),
								bbox: null,


							});
							idx_evidence = imgs.length - 1;
							check_imgs++;
							// is_face  = true;
							/*content_img = [];
							content_img.push({
								img : img_full,
							});*/
						}
					}
					if (item.url_photo || (vinfo && vinfo.url_photo)) {
						let temp_vphoto = vinfo && vinfo.url_photo ? vinfo.url_photo : ''
						let temp_photo = item.url_photo || temp_vphoto;
						// console.log( "url_photo IMG ", temp_photo)

						if (temp_photo) {

							img_segment = url_temp + temp_photo;
							img_full = img_full ? img_full : img_segment;
							imgs.push({
								img: img_segment,
								title: this.ml.get('current_photo'),
								bbox: null,
							});
							// is_face  = true;
							check_imgs++;

						}

					}

					if (item.trained_thumbnail || (vinfo && vinfo.trained_thumbnail)) {
						let temp_vtrained = vinfo && vinfo.trained_thumbnail ? vinfo.trained_thumbnail : '';
						let temp_thumbnail = item.trained_thumbnail || temp_vtrained;
						img_thumbnail = url_temp + temp_thumbnail;
						// console.log( "img_thumbnail ", img_thumbnail)

						if (img_thumbnail) {

							imgs.push({
								img: img_thumbnail,
								title: this.ml.get('trained_photo'),
								bbox: null,
							});
							// is_face  = true;
							check_imgs++;
						}

					}
					if (check_imgs == 3 && idx_evidence >= 0) {
						imgs[idx_evidence].col = 12;
					}

					// analytic1 		= 'face';


					if (imgs && imgs.length > 0) {
						new_format.images = imgs;
					}

				} else
					if (item.vehicle_image_url) {
						img_full = url + '/' + item.vehicle_image_url;
						new_format.images.push({
							img: img_full,
						});
					}
		if (analytic == "parking") {

			if (item.entry) {

				let name_dev = this.ml.get("not_found_device");
				if (item.entry.device) {
					name_dev = item.entry.device.name;
				}

				imgs.push({
					img: url + "/" + item.entry.full_photo,
					title: name_dev,
				})
				entry_full_photo1 = url + "/" + item.entry.segment_photo;

			}
			if (item.exit) {
				let name_dev = this.ml.get("not_found_device");
				if (item.exit.device) {
					name_dev = item.exit.device.name;
				}
				imgs.push({
					img: url + "/" + item.exit.full_photo,
					title: name_dev,
				})

				exit_full_photo1 = url + "/" + item.exit.segment_photo;
			}
			if (item.entry) {
				imgs.push({
					img: url + "/" + item.entry.segment_photo,
					// title 		: this.ml.get("segment"),
					// is_segment1 : true,
					height: 100,
				})
			}
			if (item.exit) {
				imgs.push({
					img: url + "/" + item.exit.segment_photo,
					// title 		: this.ml.get("segment"),
					height: 100,
					// is_segment1 : true,
				})
			}

			if (imgs && imgs.length > 0) {
				new_format.images = imgs;
			}
		}


		if (new_format && new_format.images && new_format.images.length === 0) {
			new_format.images.push({
				img: img_full,
			});

		}
		if (analytic == "audios") {
			if (item.url_audio) {
				audioo = url + item.url_audio;
			}
		}

		// console.log("FORMAT ELse", img_full, new_format)

		return {
			img_full,
			img_segment,
			img_thumbnail,
			content_1: {
				is_face,
				content_img,
				is_selection,
			},
			exit_full_photo1,
			entry_full_photo1,
			audioo,
			imgs,
			style_image,
			height_image,
		}
	}
	check_device(item, vinfo, analytic, new_format) { // name device && locations
		let device_name = this.ml.get('not_found_device');
		let lat = null;
		let long = null;
		let locationss = [];
		let device_Id = null;
		let pc = this.ml.get('not_found');
		let icon_tech = '';
		let name_peripheral = this.ml.get('not_found');
		let entry_device_name1 = this.ml.get('not_found_device');
		let entry_event_type1 = null;
		let exit_device_name1 = this.ml.get('not_found_device');
		let exit_event_type1 = null;
		let device_Id_entry1 = null;
		let device_Id_exit1 = null;
		let key = item.deviceId ? 'deviceId' :
			item.hostId ? 'hostId' :
				item.host_id ? 'host_id' : 'host_Id';


		let check_locts = false; // check locaction
		if (item.latitude && item.longitude && (item.latitude != "0" || item.longitude != "0")) {
			check_locts = true;
			let long = item.longitude;
			let lat = item.latitude;
			locationss.push({
				latitude: lat,
				longitude: long,
				name: device_name,
			});
		}

		if (item[key]) {
			// console.time()
			let device = this.render_device(item[key]);
			device_Id = item[key];
			// console.timeEnd()

			if (device) {
				device_name = device.name;
				// device_Id 		  = device.deviceId;
				new_format.device = device_name;
				if (!check_locts && (device.latitude && device.longitude) &&
					(device.latitude != "0" || device.longitude != "0")) {
					lat = device.latitude;
					long = device.longitude;
					locationss.push({
						latitude: lat,
						longitude: long,
						name: device_name,
						deviceId: device.deviceId,
					})
				} else if (check_locts && locationss && locationss.length > 0 && locationss[0]) {
					locationss[0].name = device_name;
					locationss[0].deviceId = device.deviceId;
				}
				if (item.detail) {

					let det = item.detail;
					try {
						if (typeof det == 'string') {
							det = JSON.parse(det);
						}
					} catch (er) {
						console.log("error convert detail ", er);
					}
					if (det.pc) {
						pc = det.pc;
					}
					if (det.icon) {
						icon_tech = det.icon;
					}
				}

			} else {

				/*if (item[key] && this.list_no_devs.some(x => (item[key].includes(x)))) {
					device_name = item[key];
					if (item[key].includes('pc')) {
						pc 			= item[key].split('pc_')[1];
					}
				}else */
				if (item.detail) {
					try {
						let det = item.detail;
						try {
							if (typeof det == 'string') {
								det = JSON.parse(det);
							}
						} catch (er) {
							console.log("error convert detail ", er)
						}
						if (det) {
							if (det.device_name) {
								device_name = det.device_name;
							}
							if (det.pc) {
								// device_name += det.pc + "_";	
								pc = det.pc;
							}
							if (det.icon) {
								icon_tech = det.icon;
							}
						}

					} catch (e) {
						console.warn("Error convert parse ", e);
					}
				}

			}
		}
		if (item.name_peripheral) {
			name_peripheral = item.name_peripheral;
		}

		new_format.device = device_name;
		// new_format.peripheral = 

		// parking
		if (item.entry) {
			if (item.entry.device) {
				device_Id_entry1 = item.entry.device.deviceId;
				entry_device_name1 = item.entry.device.name;
			} else if (item.entry.deviceId) {
				device_Id_entry1 = item.entry.deviceId;
				let temp = this.render_device(item.entry.deviceId);
				if (temp) {
					entry_device_name1 = temp.name;
				}
			}
			entry_event_type1 = item.entry.evnt_type;

		}
		if (item.exit) {
			if (item.exit.device) {

				exit_device_name1 = item.exit.device.name;
				device_Id_exit1 = item.exit.device.deviceId;
			} else if (item.exit.deviceId) {
				device_Id_exit1 = item.exit.deviceId;
				let temp = this.render_device(item.exit.deviceId);
				if (temp) {
					exit_device_name1 = temp.name;
				}
			}
			exit_event_type1 = item.exit.evnt_type;

		}

		return {
			device_name,
			locationss,
			device_Id,
			pc,
			icon_tech,
			name_peripheral,
			entry_device_name1,
			exit_device_name1,
			device_Id_entry1,
			device_Id_exit1,
			entry_event_type1,
			exit_event_type1,
		}
	} // check device

	check_date(item, vinfo, analytic, new_format) {
		let datee = null;
		let entry_date1 = null;
		let exit_date1 = null;
		let datee1 = "N/A";
		if (item.timestamp) {
			datee = this.format_date(item.timestamp);
		} else
			if (item.unix_itme_stamp) {
				datee = this.format_date(item.unix_itme_stamp);
			}
			else if (item.createdAt) {
				datee = this.format_date(item.createdAt, 'createdAt');
			}
			else if (vinfo && vinfo.unix_itme_stamp) {
				datee = this.format_date(vinfo.unix_itme_stamp);

			} else if (vinfo && vinfo.createdAt) {
				datee = this.format_date(vinfo.createdAt, 'createdAt');

			} else if (vinfo && vinfo.date) {
				datee = this.format_date(vinfo.date, 'createdAt');
			}
		if (analytic == "parking") {
			// console.log("CHECK DATE ** ", item.exit)
			if (item && item.entry && item.entry.timestamp) {
				entry_date1 = this.format_date(item.entry.timestamp);
			}
			if (item && item.exit && item.exit.timestamp) {
				exit_date1 = this.format_date(item.exit.timestamp);
			}
			// console.log("DATES RESULT ", entry_date1, exit_date1)
		}
		new_format.date = datee;
		if (analytic == "alarms") {
			if (item.Management_incident && item.Management_incident.length > 0) { // timestamp_confirmed
				datee1 = this.format_date(item.Management_incident[0].date); // item.timestamp_confirmed
				new_format.confirmed_date = datee1;

			}
		}
		return {
			datee,
			entry_date1,
			exit_date1,
			datee1,
		}
	}

	check_videos(item) {
		let videoss = [];
		if (item.video) {
			videos.push(item.video)
		}
		return { videoss };
	} // check videos

	check_technical(item, vinfo, analytic, new_format) {
		let codee = this.ml.get('not_found');
		let modulee = this.ml.get('not_found');
		let detaill = this.ml.get('not_found');
		let typee = this.ml.get('not_found');
		let statee = this.ml.get('unknown');
		let tag_tech = "";
		let color_tech = "secondary";
		let img_tech1 = "";

		if (item.code) {
			codee = item.code;
			detaill = this.ml.get(item.code) ? this.ml.get(item.code) : null;

		}
		if (item.module) {
			modulee = item.module;
		}
		if (item.detail) {
			// detaill = item.detail;
		}
		if (item.type) {
			typee = item.type;
		}

		if (item.state >= 0 || item.state == -1) {
			statee = parseInt(item.state);
			if (codee == "AG_BK_RECORD_002") {
				img_tech1 = this.EXT + "/img/tags/record/grey.png";
			}
			if (statee === 0) {
				// img_tech1 	= this.EXT + "/img/tags/success/success.png";
				color_tech = "success";
			} else if (statee == 1) {
				// img_tech1 	= this.EXT + "/img/tags/alert/alert.png";
				color_tech = "warning";

			} else if (statee == 2) {
				// img_tech1 	= this.EXT + "/img/tags/warning/warning.png";
				color_tech = "error";
			} else if (item.state == -1) {
				color_tech = "primary";
			}
			else {
				// img_tech1 	= this.EXT + "/img/tags/normal/normal.png";

			}
			if (item.type) {
				color_tech = item.type;
			}
		}
		return {
			codee,
			modulee,
			detaill,
			typee,
			statee,
			color_tech,
			img_tech1
		}
	}

	check_details(item, vinfo, analytic, new_format) {
		let detail_action = this.ml.get('not_found');
		let is_confirmed_1 = "N/A";
		let false_positive1 = "N/A";
		let is_incident_1 = "N/A";
		let is_incident_bool = "N/A";
		let type_incident_1 = "";
		let color_type_incident_1 = "";
		if (analytic == 'peripherals') {
			if (item.detail) {
				detail_action = item.detail;
			}
		}
		if (analytic == 'parking') {


			if (item.status) {
				new_format.timelapse = item.status.parked_time;
				new_format.status = item.status.status;
				item.parked_time = item.status.parked_time;
				item.status_parked = item.status.status;
				item.status_color_parked = item.status.color;
			}
		}
		if (analytic == 'alarms' || analytic == 'smart_event') {
			if (item.owner) {
				new_format.owner = item.owner;
			}
			if (item.is_confirmed) {
				is_confirmed_1 = this.ml.get("confirmed");
				type_incident_1 = this.ml.get("confirmed_alert");
				color_type_incident_1 = "success";
			} else {
				is_confirmed_1 = this.ml.get('unconfirmed_alert')
			}
			if (item.is_ignored && !type_incident_1) {
				type_incident_1 = this.ml.get("ignored_alert");
				color_type_incident_1 = "error";
			}
			if (item.is_fp) {
				false_positive1 = this.ml.get("confirmed");
				if (!type_incident_1) {
					type_incident_1 = this.ml.get("false_positive");
					color_type_incident_1 = "warning";
				}
			} else {
				false_positive1 = this.ml.get('unconfirmed_alert')
			}
			if (item.Management_incident && item.Management_incident.length > 0) {
				is_incident_1 = this.ml.get("confirmed");
				is_incident_bool = true;
				// type_incident_1 			= item.Management_incident[0].name;    
				if (!type_incident_1) {
					color_type_incident_1 = "primary";
					type_incident_1 = this.ml.get("automatic_activation");
				}

			} else {
				is_incident_1 = this.ml.get('unconfirmed_alert');
				is_incident_bool = false;
				if (!type_incident_1) {
					color_type_incident_1 = "secondary";
					type_incident_1 = this.ml.get("unconfirmed_alert");
				}
			}

			/*is_incident_bool
				item.is_confirmed
				
			item.is_fp*/
		}

		if (["face", "face_detected", "alarms", "smart_event"].includes(analytic)) {
			if (item.user_trained) {
				if (item.user_trained) {
					new_format.title_sub_content = this.ml.get("similarity_information")
					new_format.username = item.user_trained.userName;
					new_format.faceUUID = item.user_trained.userId;
				}
			}
		}
		return {
			detail_action,
			is_confirmed_1,
			false_positive1,
			is_incident_1,
			is_incident_bool,
			color_type_incident_1,
			type_incident_1,
		}
	}

	check_user(item, vinfo, analytic, new_format) {
		let userr = null;
		let user_and_type = "N/A";
		let type_userr = "";
		let user_name = this.ml.get("not_found");
		let action_done_1 = "N/A";
		// console.log("check USER *******************", this.list_users)
		if (item.user) {
			let temp_user = null;
			try {
				temp_user = this.Helper.to_object(item.user);
				if (typeof temp_user == "string") {
					temp_user = this.Helper.to_object(temp_user);
				}
			} catch (e) {
				console.log("Error convert to object user ", e)
			}
			if (temp_user) {
				userr = this.format_user(item.user);
			}

		}
		if (analytic == "alarms" || analytic == "smart_event") {
			if (item.Management_incident && item.Management_incident.length > 0 && item.Management_incident[0]) {
				item.userId = item.Management_incident[0].userId;
				if (item.Management_incident[0].descriptions && item.Management_incident[0].descriptions.length > 0) {
					action_done_1 = item.Management_incident[0].descriptions[0].description;
				}
			}
		}
		if (item.userId && !userr) {
			userr = this.format_user({
				userId: item.userId
			});
		}
		if (userr) {
			if (item.type_user) {
				type_userr = '- ' + item.type_user;
			}
			user_and_type = `${userr.Username} ${type_userr}`;
			user_name = userr.Username;
		}

		return {
			userr,
			user_and_type,
			user_name,
			action_done_1,
		}
	}


	render_formated(item, vinfo, analytic, new_format, content_1, videoss, locationss, alert_1, valert_1) {

		// construct formated
		let is_alarm, is_to_confirm;
		if (vinfo) {
			if (["alarms"].includes(analytic)) {
				new_format.title_sub_content1 = this.ml.get("alert_information")
				if (item.id) {
					new_format.id = item.id;
				}

				if (vinfo.name) {
					new_format.alarm_name = vinfo.name
				}
				if (vinfo.Detail_device_alarm && vinfo.Detail_device_alarm.length > 0) {
					if (vinfo.Detail_device_alarm[0] && vinfo.Detail_device_alarm[0].detail_schedule_device && vinfo.Detail_device_alarm[0].detail_schedule_device.length > 0) {
						let temp_sched = vinfo.Detail_device_alarm[0].detail_schedule_device[0];
						new_format.schedule = `${temp_sched.start} - ${temp_sched.end}`
						new_format.interval = temp_sched.interval;
					}
				}
				try {
					// console.log("vinfo.Detail_action_alarm ,", vinfo.Detail_action_alarm)


					if (vinfo && vinfo.Detail_action_alarm && vinfo.Detail_action_alarm.length > 0) {
						is_alarm = vinfo.Detail_action_alarm[0].isalert;
						is_to_confirm = vinfo.Detail_action_alarm[0].manual_confirmation;
						alert_1.isPopup = vinfo.Detail_action_alarm[0].ismodal;
						alert_1.isSound = vinfo.Detail_action_alarm[0].issound;
						if (alert_1 && vinfo.Detail_action_alarm[0].timeout) {
							alert_1.timeout = vinfo.Detail_action_alarm[0].timeout;
						}
					} else {
						if (vinfo.Detail_action_alarm) {
							is_alarm = vinfo.Detail_action_alarm.isalert;
							is_to_confirm = vinfo.Detail_action_alarm.manual_confirmation;

							if (alert_1 && vinfo.Detail_action_alarm.timeout) {
								alert_1.timeout = vinfo.Detail_action_alarm.timeout;
							}
						}
					}

				} catch (er) {
					console.warn("Error set info alert of alarms ", er)
				}

			}
		}


		// set content

		let formated = {
			content: new_format,
			vinfo,
			is_alarm,
			is_to_confirm,
			alert_confirmed: item.is_confirmed || false,
			false_positive: item.is_fp || false,
		};
		// if (item.invoice) {
		// console.log("formate ********* ", analytic, formated, item)
		// }
		if (analytic == "parking") {
			delete formated.content.tags; delete formated.content.device; delete formated.content.probability;
		}
		if (item && item.invoice && item.invoice.length > 0) { //
			let total = 0;
			item.invoice.forEach((inv, idx_inv) => {
				// console.log("********************", 'content'+ (idx_inv + 1))					
				if (inv && !Array.isArray(inv)) {


					formated['content' + (idx_inv + 1)] = { ...inv };
					if (inv.subtotal) {
						total += inv.subtotal;
					}
				}
			})
			item.total_invoice = total;

		}

		// set content1
		if (content_1) {
			// console.log("FORMAT content1 ++++++++++++++++++++++++++++", content_1)
			if (content_1.is_face && content_1.content_img && analytic == "face_detected") {

				formated.content1 = {
					images: content_1.content_img,

				};
				if (analytic.includes('face_detected')) {
					formated.content1.toolbar = {
						color: "primary",
						text: this.ml.get("cropping_faces"),
						cols: 12,
						order: 'first',
					};

					formated.content1.title_sub_content = this.ml.get("to_train")
					formated.content1.fields = {
						cols: 12,
						order: 'last',
						class: "",
						list_fields: [
							{
								key: "trained",
								type: "select",
								text: this.ml.get("trained_user"),
								class: "pa-0",
								list: this.list_traineds,
								item_text: "userName",
								show_face: true,
								hide_detail: false,
								height: "15",
								col: 12,
								return_obj: true,
								show_if: "name",
								key_img: "url_face",
								filter_key: "userName",
								is_filter: true,
								list_filter: [],
								request_search: {
									type: "post",
									url: "/api/v1/face/trained_find",
									not_limit: true,
								},
								is_required: true,
								persistent_hint: true,
								hint: this.ml.get("required"),
							},
							{
								key: "date_at",
								type: "text",
								text: this.ml.get("createdAt"),
								disabled: true,
								col: 12,
								show_if: "name",
								class: "",

							},
							{
								key: "name",
								type: "text",
								text: this.ml.get("name"),
								class: "pa-0",
								height: "15",
								col: 12,
								show_if: "trained",
								is_required: true,
								hide_detail: false,
								persistent_hint: true,
								hint: this.ml.get("required"),

							},
						],
						list: [

							{
								key: "to_train",
								color: "primary",
								action: "trained", // confirm_
								text: this.ml.get("to_train"),
								col: 4,
								action_show: "show_in_btn",
								show_in: { valid: ['name', 'trained'] }

							}

						]
					};
				}
			}
		}

		if (valert_1) {
			formated.content2 = valert_1;
		}
		// set alert
		if (alert_1) {
			formated.alert = alert_1;
		}

		// set locations
		if (locationss && locationss.length > 0) {
			formated.locations = locationss;
		}

		// set videos
		if (videoss && videoss.length > 0) {
			formated.videos = videoss
		}

		return formated;
	} // render formated


	/*
		STANDART FORMATED

		formated = {
			// setting
			settings : {	
				order_col : {
					content1  : 0, // 
					content   : 1, // default
					locations : 2,
					videos    : 3,

				},
				width_col : {
					content 	: 12,
					content1 	: 12,
					locations   : 12,
					videos 		: 12,
				},
			},

			content : {

				images 		: [
					{ 
						img  : img_photo,
						bbox : bounding,
						is_segment : false, // for littes photos
						height     : false // for images heigth
						width      : string, //
						col 	   : 12 || 6 ,//
						fit 	   : initial, cover, contain,  node, fill
					}
				] ,
				// id 			: item.id ? item.id : null,
				device 		: devicename,
				// img 		: img_photo,
				tag 		: tag1, // important
				tags 		: tags,
				motive 		: motive1,
				duration 	: duration1 + ' seg',
				probability : probability1 + ' %',
				date 		: time_stamp, // important
				bbox 		: b_box,
				// uuid
				// from		 			
			},
			alert 		: alert1, 
			}
			content1 : images 		: [
					{ 
						img  : img_photo,
						bbox : bounding,
					}
				] ,
			locations : [
				{
					latitude  : '',
					longitude : '',
				}
			],
			videos : {
				url 	 : '' // case url
				date_utc : '' // required for video : createdAt
				deviceId : '' //  optional
				name     : '' //  optional : name device
				id_device : '' // required for video : id of device 
			}, 
			analytic : '', // !important 
			table    : { // for show in table
				img 	 : '','',
				device   : '','', // name device
				tag  	 : '','', // tag action
				date	 : timestamp || createdAt, // important :  momentz ().format('ll, LTS')

			}
		}; // formated

	*/

	format_user(user) {
		if (user) {

			if (this.list_users && this.list_users.length > 0) {

				let idx = this.list_users.findIndex(x => (x && x.id == user.userId));

				if (idx >= 0) {
					return this.list_users[idx];
				}
			}
		}
		return null;
	}

	render_incident(item) {
		if (item) {
			let formated = { ...item };
			formated.datee = this.format_date(formated.date);
			formated.action = "select_incident";
			return formated;
		}
	}
	render_incident_desciption(item) {
		if (item) {
			item.datee = this.format_date(item.date);
			let temp = this.format_user(item);

			if (temp) {
				item.username = temp.Username;
			} else {
				item.username = this.ml.get("not_found");
			}
			return item;
		}
		return null
	}

	create_permissions_user(list) {
		if (list && list.length > 0) {
			const api = this.URL + "/api/v1/permission";
			const api1 = this.URL + "/api/v1/resource";
			list.forEach(async (item) => {
				if (item && item.resourceId) {
					console.log("create permission : ", item)
					await this.axios.post(api, item).then(res => {
						return true;
					}).catch(err => {
						console.warn("Error create permission ", err)
						return err;
					})
				} else {
					console.log("create resource : ", item)

					let info_up = {
						name: item.name,
						description: "resource added by default" + item.name,
						state: true,
						type: item.type,
					}
					await this.axios.post(api1, info_up).then(res => {
						return true;
					}).catch(err => {
						console.warn("Error create resource ", err)
						return err;
					})
				}
			});
		}

	}

	// render info events
	format_info(item, analytic, opt, realtime = false) { // object / type analytic / opt = alert , info, other;
		// console.log("format info",realtime)
		let formated = null;
		let ext = this.EXT;
		let url = this.URL;
		let url_face = this.URL_face + ext;
		let locationss = [];
		let location = {}; // location individual
		let videoss = null;
		let loc_lat = null;
		let loc_long = null;
		let device = null;
		let table = null;
		let img_segment = null;
		let img_full = null;
		let imgs = {};
		let device_name = 'Not found device';
		let tag_format = 'Not found tag';
		let tags_format = [];
		let date_format = null;
		let probability1 = 'Not found';
		let v_info = null;
		let settingss = {
			order_col: {
				content1: 0, // 
				content: 1, // default
				locations: 2,
				videos: 3,

			},
			width_col: {
				content: 12,
				content1: 12,
				locations: 12,
				videos: 12,
			},
		};
		if (opt !== 'table') {
			if (this.debug && this.debug.logs) {
				console.log("ALERT FORMAT CLASS : \n analytic :",
					analytic, " \n option : ",
					opt, "\n item : ",
					item
				);
			}
		}

		let new_format = {
			images: [],
			device: 'Not found device',
			tag: 'Not Found tag',
		};
		let new_format_speed = new_format;

		if (item) {

			if (item.vinfo) {

				try {
					if (typeof item.vinfo == 'string') {
						let obj = JSON.parse(item.vinfo);
						v_info = obj;
						if (typeof obj == "string") {
							vinfo = JSON.parse(obj);
						}
						// item 	 = obj; 
						/*if (obj && obj.analytics_results && obj.analytics_results.length > 0) {
							results = obj.analytics_results;
						}*/
					}
				} catch (er) {
					console.warn("Error converting parse vinfo", er)
				}
			}

			if (analytic == 'lpr' || analytic == 'speed') {
				if (analytic == 'lpr') {
					let plate = '';
					let event_lpr = item.event ? item.event : item;
					let check_lpr = [
						'speed',
						'speed_limit'];
					if (event_lpr.vinfo && typeof event_lpr.vinfo == 'string') {
						event_lpr = JSON.parse(event_lpr.vinfo);
						event_lpr.full_photo = event_lpr.full_photo_path;
						event_lpr.segment_photo = event_lpr.segment_photo_path;
					}
					if (event_lpr) {
						let key = item.deviceId ? 'deviceId' :
							item.hostId ? 'hostId' :
								item.host_id ? 'host_id' : 'host_Id';
						let device_id = item[key];

						// other content

						if (event_lpr.host) {
							if (event_lpr.host.name) {
								new_format.device = event_lpr.host.name;
								device = event_lpr.host;
							} else if (event_lpr.host.hostId) {
								device = this.render_device(event_lpr.host.hostId);
								device_id = event_lpr.host.hostId
								if (device) {
									new_format.device = device.name;
								}

							}

						} else if (event_lpr.device) {
							device = event_lpr.device;
							new_format.device = device.name;
						} else if (event_lpr.deviceId) {
							device_id = event_lpr.deviceId;
							device = this.render_device(event_lpr.deviceId);
							new_format.device = device.name;
						}
						/*if (!device) {
							device 			  = this.render_device(event_lpr.deviceId); 
						}*/

						new_format.tag = "lpr";
						if (event_lpr.tag) {
							new_format.tag = event_lpr.tag;
						}

						check_lpr.forEach((item_lpr) => {
							if (item_lpr && event_lpr[item_lpr]) {
								new_format[item_lpr] = event_lpr[item_lpr] + " Km/s";
							}
						}); // check lpr
						if (event_lpr.plate_chars) {
							plate = event_lpr.plate_chars;
							new_format.plate_chars = plate;
						}

						if (item.categorie && item.categorie.length > 0) {
							new_format.tag = item.categorie[0].name;
						} else if (item.name_categorie) {
							new_format.tag = item.name_categorie;
						}
						// step case AVG speed
						if (item.point_a && new_format.category == 'Speed-Avg') {
							new_format_speed = this.format_info({
								point: item.point_a,
								speed: item.infoSpeed || item.infospeed,
							}, 'speed');
						} else {
							new_format_speed = null;
						}

						if (item.motive_categorie) {
							new_format.motive = item.motive_categorie;
						}

						// step date
						if (event_lpr.timestamp) {
							new_format.date = this.format_date(event_lpr.timestamp);
							date_format = new_format.date;
						}

						//step imgs
						if (event_lpr.full_photo) {

							new_format.images.push({
								img: url + '/' + event_lpr.full_photo,
								// is_segment  : true,
							});

						}
						if (event_lpr.top_image) {

							new_format.images.push({
								img: url + '/' + event_lpr.top_image,
								is_segment: true,
							});
						}
						img_segment = '/img/no_img_found.png';
						if (event_lpr.segment_photo) {
							img_segment = url + '/' + event_lpr.segment_photo;
							new_format.segment = {
								img: url + '/' + event_lpr.segment_photo,
								is_segment: true,
								height: '75px',
								title: this.ml.get('segment'),
								fit: 'cover',
								col: 6,
							};
						}

						// console.log("IMagES ----------------------------- ", img_segment, event_lpr.full_photo, new_format.images)


						// step locations
						if (event_lpr.latitude && event_lpr.longitude) {
							loc_lat = event_lpr.latitude;
							loc_long = event_lpr.longitude;
						} else if (item.host && item.host.latitude && item.host.longitude) {
							loc_lat = item.host.latitude;
							loc_long = item.host.longitude;
						} else {
							if (device && device.latitude && device.longitude) {
								loc_lat = device.longitude;
								loc_long = device.latitude;
							}
						}


						if ((loc_lat && loc_long) && (loc_lat != '0' || loc_long != '0')) {

							locationss.push({

								latitude: loc_lat,
								longitude: loc_long,
								name: device && device.name ? device.name : '',
							});
						}

						// step set videos 
						if (event_lpr.createdAt && device) {

							videoss = {
								url: event_lpr.video ? url + event_lpr.video : null,
								date_utc: event_lpr.createdAt,
								id_device: device.id,
							}
						}


						// construct formated

						// set content
						formated = {
							content: new_format,
						}

						// set content1 if exist of speed : point A

						if (new_format_speed) {
							console.log("SPEED : ", new_format_speed);
							if (new_format_speed.content) {
								formated.content1 = new_format_speed.content;
							}
							if (new_format_speed.location) {
								locationss.push(location);
							}
						}

						// set locations 
						if (locationss && locationss.length > 0) {
							formated.locations = locationss;
						}


						// set videos
						if (videoss) {
							formated.videos = videoss;
						}

						// if type alert

						if (opt == 'alert') {
							// step end  alert
							if (item.valert) {
								formated.alert = item.valert;
							} else {
								// for test
								formated.alert = {
									isPopup: true,
									isSound: true,
								}
							}
						} // alert
						formated["analytic"] = analytic;
						formated["deviceId"] = device_id;
						formated["createdAt"] = item.createdAt;

						// if type table
						// if (opt == 'table') {
						let ID = null
						if (item.id) {
							ID = item.id;
						}

						table = {
							id: ID,
							img: img_segment,
							plate_chars: plate,
							tag: "lpr",
							device: device && device.name ? device.name : '',
							date: date_format,				// createdAt
							deviceId: device_id,
							speed: item.speed,
							speed_limit: item.speed_limit,
							direction: item?.direction,
							attributes: item?.attributes ? item.attributes.map(attr => {
								if (attr.type === 'color') {
									return {
										type: attr.type,
										value: attr.classname,
										probability: attr.probability,
										display: `<div class="d-flex align-center">
												<div class="color-circle mr-2" style="background-color: ${attr.classname}; width: 20px; height: 20px; border-radius: 50%;"></div>
												<span>${attr.classname}</span>
											</div>`
									};
								}
								return {
									type: attr.type,
									value: attr.classname,
									probability: attr.probability,
									display: attr.classname
								};
							}) : [],
							analytic,
							formated
						};
						// console.log("TABLE LPR : --------------------- ", table)
						return table;
						// }
						// console.log("FORMAT CLASS RETURN : ", formated);
					} else { // event_lpr
						console.warn("No exist property event for format : analytic : ", analytic, event_lpr);

					}// event_lpr else

				}// analytic lpr
				else if (analytic == 'speed') { //
					let info_speed = null;
					let speed_format = null;


					info_speed = this.format_parse_json(item.point);

					if (info_speed && info_speed.length > 0) {
						speed_format = info_speed[0].fields;
					}
					if (speed_format) {

						// step url speed
						if (speed_format.server) {
							url = speed_format.server;
						} else {
							url = 'http://202.126.92.138/media'
						}
						if (speed_format.full_photo) {
							new_format.images.push({
								img: url + speed_format.full_photo,
							})
						}
						if (speed_format.segment_photo) {
							new_format.images.push({
								img: url + speed_format.segment_photo,
							})
						}

						// step content
						new_format.plate_chars = speed_format.plate_chars;

						// step detail speed
						let speed_detail = this.format_parse_json(item.speed);
						if (speed_detail) {
							let check_speeds = [
								'speed',
								'speed_limit',
								'distance',
							];
							new_format = this.format_content(new_format, speed_detail, check_speeds, 'array');
							if (speed_detail.duration) {
								new_format.duration = parseFloat(speed_detail.duration).toFixed(2);
							}
							if (speed_detail.name_host_a) {
								new_format.device = speed_detail.name_host_a;
							}
							if (speed_detail.latitude && speed_detail.longitude) {
								loc_lat = speed_detail.latitude;
								loc_long = speed_detail.longitude;

							} else if (speed_format.latitude && speed_format.longitude) {
								loc_lat = speed_format.latitude;
								loc_long = speed_format.longitude;
							}
							if (loc_lat && loc_long) {

								location = {
									latitude: loc_lat,
									longitude: loc_long,
									name: new_format.device,
									deviceId: device && device.deviceId ? device.deviceId : "",
								};
							}

						}

						// step date
						new_format.date = this.format_date(speed_format.timestamp);

						formated = {
							content: new_format,
							location,
						};
						return formated;
						// coord

					}// speed format
				} // analytic speed

			} else { // if (['objects', 'motion', 'alerts', 'weapon_detector', 'alarms', 'face', 'actions'].includes(analytic))

				// ============================================================================ OBJECTS 

				const {
					tag_, // normal tag 
					tags_color, // array objs 
					tag_color,  // one tag obj
					format_tags, // array / tags_format, 
					bbox,
					probability_1,
					alert_1,
					valert_1,
					name_incidente,
					state_incident,
					tag_audio,
					duration_audio,
					axle_counter1,
					fieldSpeed,

				} = this.check_bbox_tags(item, v_info, analytic, new_format);
				const {
					img_full,
					content_1,
					exit_full_photo1,
					entry_full_photo1,
					audioo,
					imgs,
					style_image,
					height_image,
				} = this.check_images(item, v_info, analytic, new_format, bbox);


				const {
					device_name,
					device_Id,
					locationss,
					pc,
					icon_tech,
					name_peripheral,
					entry_device_name1,
					exit_device_name1,
					device_Id_entry1,
					device_Id_exit1,
					entry_event_type1,
					exit_event_type1,
				} = this.check_device(item, v_info, analytic, new_format);
				const { videoss } = this.check_videos(item);
				const {
					datee,
					datee1,
					entry_date1,
					exit_date1,
				} = this.check_date(item, v_info, analytic, new_format);
				const {
					codee,
					modulee,
					detaill,
					typee,
					statee,
					color_tech,
					img_tech1,

				} = this.check_technical(item, v_info, analytic, new_format);
				const {
					userr,
					user_and_type,
					user_name,
					action_done_1,
				} = this.check_user(item, v_info, analytic, new_format);
				const {
					detail_action,
					is_confirmed_1,
					false_positive1,
					is_incident_1,
					is_incident_bool,
					type_incident_1,
					color_type_incident_1,
				} = this.check_details(item, v_info, analytic, new_format)


				formated = this.render_formated(
					item,
					v_info,
					analytic,
					new_format,
					content_1,
					videoss,
					locationss,
					alert_1,
					valert_1,
					imgs
				);
				let ID = null;

				if (item.id) {
					ID = item.id;
					formated["ID"] = item.id;
				}

				let zone = null;
				if (item.device && item.device.constellations && item.device.constellations.length > 0) {
					zone = item.device.constellations[0];
				}
				formated["analytic"] = analytic;
				formated["deviceId"] = device_Id;
				formated["createdAt"] = item.createdAt;
				formated['is_confirmed'] = is_confirmed_1;
				formated['isignored'] = item.is_ignored ? true : false;
				formated['is_incident'] = is_incident_1 ? true : false;
				formated["original_source"] = item;
				formated["devices"] = item.devices;
				formated['is_ws'] = realtime;
				formated['zone'] = zone
				//console.log("FORMATED ************************+", formated, datee, device_name, locationss, audioo)
				// console.log("FORMATED ************************+",formated)

				// console.log("formated : ", formated)
				if (analytic == 'objects') {
					table = {
						id: ID,
						img: img_full,
						tags_colors: tags_color,
						device: device_name,
						date: datee,
						// bbox 		: 
						probability: probability_1,
						// item,	
						deviceId: device_Id,
						speed: fieldSpeed,
						analytic,
						formated
					};

					return table

				} // objects
				else if (analytic == 'motion') {

					table = {
						id: ID,
						'device': device_name,
						'img': img_full,
						'tags_colors': tags_color,
						'probability': probability_1,
						'date': datee,
						deviceId: device_Id,
						analytic,
						formated
					}; // list r

					return table;
				} // motion
				else if (analytic == 'alerts') {
					// if (opt == 'table') {

					table = {

						id: ID,
						'device': device_name,
						'img': img_full,
						'tags_colors': tag_color,
						'probability': probability_1,
						'date': datee,
						deviceId: device_Id,
						analytic,
						formated
					}; // list r

					return table;
					/*table = {
						'id'			: event.id,
						'categorie'		: categorie.name,
						'hostname'		: host_name,
						'plate_chars'	: event.plate_chars,
						'img_photo'		: img_photo,//_path
						'full_img'		: full_img,//_path
						'color'			: color,
						'probability' 	: probability1,
						'alert'			: alert,
						'createdAt'		: this.$moment(event.createdAt).format("YYYY-MM-DD HH:mm ss"),
						// 'entry_type': i.entry_type,
						// 'video': video, //'http://localhost:9090'+i.
						// 'top_image': segment_photo,
					};*/
					// }
				} // alerts
				else if (analytic == 'weapon_detector') {
					// if (opt == 'table') {

					table = {

						id: ID,
						'device': device_name,
						'img': img_full,
						'tags_colors': tag_color,
						'probability': probability_1,
						'date': datee,
						deviceId: device_Id,
						analytic,
						formated
					}; // list r

					return table;

					// }
				}
				// alerts
				else if (analytic.includes('face')) {
					// if (analytic == "face_detected" && !item.user_trained) {
					// return null;
					// }
					table = {
						id: ID,
						'device': device_name,
						'img': img_full,
						'tags_colors': tag_color,
						'probability': probability_1,
						'date': datee,
						deviceId: device_Id,
						style_img: style_image,
						height_img: height_image,
						analytic,
						formated,
						item,
					}; // list r
					// console.log("FACE *********** : ", table, item);

					return table;
				}// face
				else if (analytic == 'actions') {
					table = {
						id: ID,
						img: img_full,
						tags_colors: tags_color,//tags_format,
						device: device_name,
						date: datee,//date_format,
						probability: probability1,
						deviceId: device_Id,
						analytic,
						formated
					};
					return table
				}
				// actions	
				else if (analytic == 'alarms' || analytic == 'smart_event') {
					// console.log("ALARMS ******************************", analytic, formated );
					/*if (tag_color.includes("alarms")) {
						this.Helper.set_local("debug_alarm", item);
						return null;
					}
*/

					table = {

						id: ID,
						'device': device_name,
						'img': img_full,
						'tags_colors': tag_color,
						'probability': probability_1,
						'speed': item.speed ? item.speed + ' km/h' : '',
						'date': datee,
						'date1': datee1,
						'user': user_and_type,
						type_incident: type_incident_1,
						color_type_incident: color_type_incident_1,
						action_done: action_done_1,
						is_incident: is_incident_1,
						color_incident: is_incident_bool ? "success" : "secondary",
						'is_confirmed': is_confirmed_1,
						color_confirmed: item.is_confirmed ? "success" : "secondary",
						isignored: item.isignored ? this.ml.get('confirmed') : this.ml.get('not_confirmed'),
						color_ignored: item.isignored ? "success" : "secondary",
						deviceId: device_Id,
						side: item.side,
						way: item.way,
						owner: item.owner || "",
						// user 			: 	user_name,
						// date1 			: 	confirmed_date,
						false_positive: false_positive1,
						color_fp: item.is_fp ? "success" : "secondary",
						analytic,
						formated,
						item,

					}; // list r

					return table;
				} // alarms
				else if (analytic == 'technical') {

					table = {

						id: ID,
						'device': device_name,
						code: codee,
						'module': modulee,
						detail: detaill,
						type: typee,
						state: statee,
						'date': datee,
						deviceId: device_Id,
						color_tag: color_tech,
						tag: detaill,
						img_tech: img_tech1,
						icon_code: icon_tech,
						computer: pc,
						analytic,
						formated
					}; // list r
					// console.log("techical ", table)
					return table;
				}
				else if (analytic == 'peripherals') {
					table = {
						id: ID,
						name: name_peripheral,
						tags_colors: tag_color,
						'date': datee,
						detail: detail_action,
						formated,
					}
					return table;

				} else
					if (analytic == 'incidents') {
						table = {
							id: ID,
							name: name_incidente,
							device: device_name,
							// tags_colors 	: tag_color,
							type: typee,
							state: state_incident,
							'date': datee,

							formated,
						}
						return table;
					} else
						if (analytic == 'parking') {
							// console.log("parking", entry_full_photo1)
							return table = {
								...item,
								formated,
								entry_full_photo: entry_full_photo1,
								exit_full_photo: exit_full_photo1,
								entry_device_name: entry_device_name1,
								exit_device_name: exit_device_name1,
								entry_date: entry_date1,
								exit_date: exit_date1,
								device_Id_entry: device_Id_entry1,
								device_Id_exit: device_Id_exit1,
								entry_event_type: entry_event_type1,
								exit_event_type: exit_event_type1,

							};
						} else
							if (analytic == "audios") {
								return {
									id: ID,
									formated,
									audio: audioo,
									device: device_name,
									date: datee,
									name: tag_audio,
									duration: duration_audio,

								}
							} else
								if (analytic == "avc") {
									return {
										id: ID,
										device: device_name,
										vehicle_type: tag_,
										tags_colors: tag_color,
										axle_counter: axle_counter1,
										img: img_full,
										date: datee,
										formated,
									}
								}
				// BLOQUE ESPECIAL PARA COUNTER
				if (analytic === 'counter' && item) {


					let inicio = item.timestamp_start
						? this.moment(Number(item.timestamp_start)).format('YYYY-MM-DD hh:mm:ss A')
						: '';
					let fin = item.timestamp_end
						? this.moment(Number(item.timestamp_end)).format('YYYY-MM-DD hh:mm:ss A')
						: '';
					// Calcular duración en formato HH:mm:ss
					let duration = '';
					if (item.timestamp_start && item.timestamp_end) {
						const diff = Number(item.timestamp_end) - Number(item.timestamp_start);
						if (!isNaN(diff) && diff > 0) {
							const durationMoment = this.moment.utc(diff);
							duration = durationMoment.format('HH:mm:ss');
						}
					}
					// Estado visual multilanguage
					let state_label = '';
					let state_icon = '';
					const stateVal = typeof item.state === 'string' ? parseInt(item.state, 10) : item.state;
					if (stateVal === 0 || stateVal === 1) {
						state_label = this.ml.get('in_progress');
						state_icon = `<i class=\"mdi mdi-loading mdi-spin\" style=\"font-size:2rem;color:#1976d2;vertical-align:middle;\"></i>`;
					} else if (stateVal === 2) {
						state_label = this.ml.get('finished');
						state_icon = `<i class=\"mdi mdi-check-circle-outline\" style=\"font-size:2.2rem;color:#43a047;vertical-align:middle;\"></i>`;
					} else {
						state_label = this.ml.get('unknown');
						state_icon = `<i class=\"mdi mdi-help-circle-outline\" style=\"font-size:2rem;color:#bdbdbd;vertical-align:middle;\"></i>`;
					}
					// Totalizers: manejar tanto array como objeto
					let totalizers = [];
					if (item.totalizer && Array.isArray(item.totalizer)) {
						// Si viene como array (formato actual)
						totalizers = item.totalizer;
					} else if (item.totalizers && Array.isArray(item.totalizers)) {
						// Si viene como totalizers array
						totalizers = item.totalizers;
					} else if (item.totalizers && typeof item.totalizers === 'object' && !Array.isArray(item.totalizers)) {
						// Si viene como objeto, convertirlo a array
						totalizers = Object.entries(item.totalizers).map(([key, value]) => ({
							tag: key,
							value: value
						}));
					} else if (typeof item.totalizers === 'string') {
						try {
							const parsed = JSON.parse(item.totalizers);
							if (Array.isArray(parsed)) {
								totalizers = parsed;
							} else {
								totalizers = Object.entries(parsed).map(([key, value]) => ({
									tag: key,
									value: value
								}));
							}
						} catch (e) {
							totalizers = [];
						}
					}
					// console.log('📊 [FORMAT] Final totalizers for counter:', totalizers);
					return {
						id: item.id,
						barcode: item.barcode,
						device_name,
						deviceId: device_Id,
						timestamp_start: item.timestamp_start,
						timestamp_end: item.timestamp_end,
						inicio,
						full_photo_url_start: item.full_photo_url_start || '',
						fin,
						full_photo_url_end: item.full_photo_url_end || '',
						duration, // nuevo campo
						totalizers, // nuevo campo
						state: item.state,
						state_label,
						state_icon
					};
				}

			} // check group 



		} // item
		else {
			console.warn("No exist item for format : analytic : ", analytic, item);
		}
		return formated;
	} // format_info

	/**
	 * Sustituye host:puerto por path de reverse proxy (/hls, /webrtc) solo si API.reverse_proxy.
	 */
	_reverseProxyStreamPath(rtsp_tmp, proxyPath) {
		if (!this.API || !this.API.reverse_proxy || !rtsp_tmp.includes(':')) {
			return rtsp_tmp;
		}
		const tmp = rtsp_tmp.indexOf(':', 6);
		const tmp1 = rtsp_tmp.indexOf('@');
		const tmp2 = rtsp_tmp.indexOf('/', 8);
		if (tmp1 < 0) {
			return rtsp_tmp.replace(rtsp_tmp.substring(tmp, tmp2), proxyPath);
		}
		return rtsp_tmp.replace(rtsp_tmp.substring(tmp, tmp1), proxyPath);
	}

	/**
	 * Sustituye el puerto de la URL (http/https) por `newPort`.
	 * Ej: http://user:pass@ip:8554/foo -> http://user:pass@ip:8888/foo
	 */
	_replaceStreamPort(url, newPort) {
		if (!url || typeof url !== 'string') {
			return url;
		}
		const schemeIdx = url.indexOf('://');
		if (schemeIdx < 0) {
			return url;
		}
		const afterScheme = schemeIdx + 3;
		const atIdx = url.indexOf('@', afterScheme);
		const hostStart = atIdx >= 0 ? atIdx + 1 : afterScheme;
		const colonIdx = url.indexOf(':', hostStart);
		if (colonIdx < 0) {
			return url;
		}
		const slashIdx = url.indexOf('/', colonIdx);
		const endIdx = slashIdx >= 0 ? slashIdx : url.length;
		return `${url.slice(0, colonIdx)}:${newPort}${url.slice(endIdx)}`;
	}

	format_local_hls(device, type = "local", channel = 1) {
		if (device) {
			const { name, deviceId, manager_id, rtsp, rtsp2, id } = device;
			const { ip, protocol } = this.API;
			if (manager_id) {
				let rtsp_tmp = channel == 1 ? rtsp : rtsp2;
				if (!rtsp_tmp) {
					return null;
				}
				if (type == "local") {
					return rtsp_tmp;
				} else {
					if (rtsp_tmp.includes("rtsp")) {
						rtsp_tmp = rtsp_tmp.replace('rtsp://', protocol);// "http"
					}
					// Dos estrategias:
					// - reverse_proxy=false: apuntar directo al HLS (:8888 + index.m3u8)
					// - reverse_proxy=true: usar rutas del reverse proxy (/hls + index.m3u8)
					if (this.API && this.API.reverse_proxy) {
						rtsp_tmp = this._reverseProxyStreamPath(rtsp_tmp, '/hls');
					} else {
						rtsp_tmp = this._replaceStreamPort(rtsp_tmp, '8888');
					}
					return `${rtsp_tmp}/index.m3u8`;
				}
			} else {

				if (type == "local") {
					return `rtsp://${ip}:8554/${id}-${deviceId}/${channel}`;
				} else {
					return `${protocol}${ip}:8888/${id}-${deviceId}/${channel}/index.m3u8`; // http://
				}
			}
		}
	} // format_hls

	format_local_webRTC(device, type = "local", channel = 2) {
		if (device) {
			const { name, deviceId, id, rtsp, rtsp2, manager_id } = device;
			const { ip, protocol } = this.API;

			if (channel == 'WEBRTC-LPR') {
				if (type == 'local') {
					return `${protocol}${ip}:8889/out/${deviceId}/`;
				}
			}

			if (manager_id) {
				if (type == "local") {
					return `${protocol}${ip}:8889/${id}-${deviceId}/${channel}/`;
				} else {
					let rtsp_tmp = channel == 1 ? rtsp : rtsp2;
					if (!rtsp_tmp) {
						return null;
					}
					if (rtsp_tmp.includes("rtsp")) {
						rtsp_tmp = rtsp_tmp.replace('rtsp://', protocol);// "http"
					}
					// Dos estrategias:
					// - reverse_proxy=false: apuntar directo al WebRTC (:8889)
					// - reverse_proxy=true: usar rutas del reverse proxy (/webrtc)
					if (this.API && this.API.reverse_proxy) {
						rtsp_tmp = this._reverseProxyStreamPath(rtsp_tmp, '/webrtc');
					} else {
						rtsp_tmp = this._replaceStreamPort(rtsp_tmp, '8889');
					}
					return `${rtsp_tmp}/`;
					// return `${protocol}${ip}/webrtc/${id}-${deviceId}/${channel}/`;
				}
			} else {
				return `${protocol}${ip}:8889/${id}-${deviceId}/${channel}/`;
			}
		}
		return null;
	}


	format_devices_points(check = [null], item) {
		const default_points = [
			{
				point1: [
					"0.0102",
					"0.0160"
				],
				point2: [
					"0.9918",
					"0.0160"
				],
				point3: [
					"0.9918",
					"0.9840"
				],
				point4: [
					"0.0102",
					"0.9840"
				]

				/*height : 0.9920,
				left   : 0.0051,
				top    : 0.0080,
				width  : 0.9949,*/
			}
		];
		let list = this.store.getters['Devices/list'];
		let list_temp = [];
		let points_temp = default_points;
		let schedule = {
			"interval": ["daily"],
			"start": "00:00",
			"end": "23:59",
			"timeZone": this.PARAMETERS && this.PARAMETERS.timezone ? this.PARAMETERS.timezone : this.momentz && this.momentz.tz ? this.momentz.tz.guess() : "",
		};
		if (list && list.length === 0) {
			list = this.Helper.get_local('list_devices');
		}


		if (list && list.length > 0) {
			// console.log("CHECK Devices ", check)
			list.forEach(dev => {
				if (dev && dev.deviceId) {
					if (!check.includes(dev.deviceId)) {

						list_temp.push({
							deviceId: dev.deviceId,
							name: dev.name,
							state: check && check.length === 0 ? true : false,
							type: dev.type ? dev.type : 'IP CAM',
							points: points_temp,// JSON.stringify()	 
							schedule: schedule,
							alarmId: item && item.alarmId ? item.alarmId : null,
							device_status: {
								color: "primary",
								icon: "mdi-cctv-off",
								text: "device_disconnected",
								code: "AG_BK_RTSP_00-1",
							}
						})
					}



				}
			})
			this.Helper.set_local("device_alarm", list_temp);
			return list_temp;
		} else {
			console.log("No found list Devices : Setting Alarms")
			return [];
		}
	}

	report_export_excel(ref, items, device_name, Formats, load, list = [], cont = 0) {
		if (items && items.length > 0) {
			let device_name_tmp = device_name;
			// for (let rpt of items) {
			let rpt = items.shift();

			if (rpt) {
				if (!device_name) {
					let temp = this.render_device(rpt.deviceId);
					if (temp) {
						device_name_tmp = temp.name
					} else {
						device_name_tmp = this.ml.get("not_found_device");
					}
				}

				let report = {
					[this.ml.get('id')]: rpt.id,
				} // report
				if (ref == "avc") {
					report[this.ml.get("device")] = device_name_tmp;
					report[this.ml.get("vehicle_type")] = rpt.vehicle_type;
					report[this.ml.get("axle_count")] = rpt.axle_count;
					report[this.ml.get("date")] = this.format_date(rpt.timestamp, 'timestamp', "YYYY-MM-DD HH:mm ss");
				} else if (ref == "lpr") {
					report[this.ml.get('device')] = device_name_tmp;
					report[this.ml.get('plate')] = rpt.plate_chars;
					report[this.ml.get('date')] = this.momentz(parseInt(rpt.timestamp, 10)).format("YYYY-MM-DD HH:mm ss");

				} else if (ref == "parking") {
					// Placa    Fecha de Ingreso    Módulo de ingreso    Tipo de Entrada    Fecha de Salida    Módulo de Salida    Tipo de Salida    Duracion    Tarifa    Impuesto(iva)    subtotal    total_charge    evnt_type(Metodo de Pago)    bill number    consecutive

					report[this.ml.get('plate')] = rpt.plate;
					if (rpt.entry) {
						if (rpt.entry.timestamp) {
							report[this.ml.get('date_of_admission')] = this.format_date(rpt.entry.timestamp, 'timestamp', "YYYY-MM-DD HH:mm ss");
						}
						if (rpt.entry.device) {
							report[this.ml.get('entry_module')] = rpt.entry.device.name;

						} else if (rpt.entry.deviceId) {
							let temp = this.render_device(rpt.entry.deviceId);
							if (temp) {
								report[this.ml.get('entry_module')] = temp.name;
							}
						}
						if (rpt.entry.evnt_type) {
							report[this.ml.get('entry_type')] = rpt.entry.evnt_type;
						}
					}
					if (rpt.exit) {
						if (rpt.exit.timestamp) {
							report[this.ml.get('departure_date')] = this.format_date(rpt.exit.timestamp, 'timestamp', "YYYY-MM-DD HH:mm ss");
						}
						if (rpt.exit.evnt_type) {
							report[this.ml.get('exit_type')] = rpt.exit.evnt_type;
						}
						if (rpt.exit.device) {
							report[this.ml.get('exit_module')] = rpt.exit.device.name;
						} else if (rpt.exit.deviceId) {
							let temp = this.render_device(rpt.exit.deviceId);
							if (temp) {
								report[this.ml.get('exit_module')] = temp.name;
							}

						}
					}
					if (rpt.status) {
						report[this.ml.get('duration')] = rpt.status.parked_time
					}
					let total = 0;
					let method = this.ml.get("not_found");
					let bill = null;
					let consecutive1 = null;
					let rate1 = 0;
					let tax1 = null;
					if (rpt.invoice && rpt.invoice.length > 0) {
						rpt.invoice.forEach((inv, idx_inv) => {
							if (inv && !Array.isArray(inv)) {


								formated['content' + (idx_inv + 1)] = { ...inv };
								if (inv.subtotal) {
									total += inv.subtotal;
								}
							}
						})
						total = this.format_price(total);
					}
					report[this.ml.get('rate')] = rpt.rate;
					report[this.ml.get('tax')] = rpt.tax;
					report[this.ml.get('subtotal')] = total; //rpt.subtotal
					report[this.ml.get('total_charge')] = total; // rpt.total_charge;
					report[this.ml.get('payment_method')] = method;
					report[this.ml.get('bill_number')] = bill;
					report[this.ml.get('consecutive')] = consecutive1;

				} else if (ref == "alarms" || ref == "smart_event") {
					let date_confirmed = '';
					let is_incident = "";
					let username = "";
					let action1 = "";
					report[this.ml.get("device")] = device_name_tmp;
					report[this.ml.get("smart_event")] = rpt.motive_categorie;
					report[this.ml.get("tag")] = rpt.tag;
					report[this.ml.get("way")] = rpt.way;
					report[this.ml.get("speed")] = rpt.speed ? rpt.speed + ' km/h' : '';
					report[this.ml.get("probability")] = rpt.probability ? parseInt(parseFloat(rpt.probability) * 100) + '%' : '';

					// report[this.ml.get("date")] 			= this.format_date(rpt.unix_itme_stamp, 'timestamp', "YYYY-MM-DD HH:mm ss");	

					// rangeAlarm/SmartEvent  / Rules / Lista / 
					if (rpt.vinfo) {
						const vInfo = typeof rpt.vinfo == "string" ? JSON.parse(rpt.vinfo) : rpt.vinfo;
						if (vInfo) {
							let smartTemp = new formatSmartEvent(Formats);
							smartTemp.setInfo(vInfo);
							smartTemp.format();
							report[this.ml.get("rules")] = smartTemp.getRulesActivesToString();
							report[this.ml.get("lists")] = smartTemp.getRulesActivesListsToString();
						}

					}



					if (rpt.is_confirmed) {
						is_incident = "confirmed_alert";
					} else if (rpt.is_ignored) {
						is_incident = "ignored_alert";
					} else if (rpt.is_fp) {
						is_incident = "false_positive";
					}
					let incidentDesciptions = [];
					if (rpt.Management_incident && rpt.Management_incident.length > 0) {

						// report[this.ml.get("is_incident")]  = this.ml.get("confirmed");
						if (!is_incident) {
							is_incident = "automatic_activation";
						}
						if (rpt.Management_incident[0]) {
							if (rpt.Management_incident[0].userId) {
								let temp = this.format_user({ userId: rpt.Management_incident[0].userId });
								if (temp) {
									username = temp.Username;
								}

							}
							if (rpt.Management_incident[0].descriptions && rpt.Management_incident[0].descriptions.length > 0) {
								action1 = rpt.Management_incident[0].descriptions[0].description;
							}
							if (rpt.Management_incident[0].date) {
								date_confirmed = this.format_date(rpt.Management_incident[0].date);
							}
						}
						rpt.Management_incident.forEach((it, idx) => {
							let userTemp = "";
							let descriptionTemp = `${this.ml.get("description")} : `;
							if (it.userId) {
								let temp = this.format_user({ userId: rpt.Management_incident[0].userId });
								if (temp) {
									userTemp = ` ${this.ml.get("username")} : ${temp.Username} , `;
								}
							}
							if (it.descriptions && it.descriptions.length > 0) {
								it.descriptions.forEach((txt) => {
									const dateDesciption = this.format_date(txt.date, "timestamp", "YYYY-MM-DD HH:mm ss");
									descriptionTemp += ` ${txt.description}, ${this.ml.get("date")} : ${dateDesciption}, `;
								})
							} else if (it.description) {
								const dateDesciption = this.format_date(it.date, "timestamp", "YYYY-MM-DD HH:mm ss");
								descriptionTemp += ` ${it.description}, ${this.ml.get("date")} : ${dateDesciption}  `
							}
							incidentDesciptions.push(userTemp + descriptionTemp)
						});
					}
					if (is_incident) {
						report[this.ml.get("type_incident")] = this.ml.get(is_incident);
					}
					else {
						report[this.ml.get("type_incident")] = this.ml.get('unconfirmed_alert');
					}
					if (username) {
						report[this.ml.get("user")] = username;
					}
					if (action1) {
						report[this.ml.get("action")] = action1;
					}
					// report[this.ml.get("confirmed_alert")]	= rpt.is_confirmed ?  this.ml.get("confirmed") : this.ml.get('not_confirmed');
					report[this.ml.get("confirmed_date")] = date_confirmed;
					report[this.ml.get("description")] = incidentDesciptions ? this.Helper.to_string(incidentDesciptions) : "";

					const date_hour = this.momentz(parseInt(rpt.unix_itme_stamp, 10)).format("YYYY-MM-DD_HH:mm ss").split("_");
					report[this.ml.get('date')] = date_hour[0];
					report[this.ml.get('hour')] = date_hour[1];

					let img = rpt.url_evidence;
					if (img.includes("alice-media")) {
						img = rpt.url_evidence.split("alice-media/")[1];
					}
					report[this.ml.get("evidence")] = { l: { Target: `${this.URL}/${img}` }, v: `${this.URL}/${img}` };
					/*const link 							= `${this.URL}/evidence_info/${ref}/${rpt.id}`;
					report[this.ml.get('evidence_link')]= { l: { Target: link  }, v :link };*/
					// report[this.ml.get("isignored")]		= rpt.is_ignored ? this.ml.get("confirmed") : this.ml.get('not_confirmed'); 
					// report[this.ml.get("false_positive")]	= rpt.is_fp ?  this.ml.get("confirmed") : this.ml.get('not_confirmed');
					const { ip, protocol, ext, base, domain } = this.API;
					let url = protocol;
					if (!ext) {
						url += domain;
					} else {
						url += `${ip}${base}`;
					}
					const link = `${url}/evidence_info/${ref}/${rpt.id}`;
					report[this.ml.get('evidence_link')] = { l: { Target: link }, v: link };

				} else if (ref == "face") {
					report[this.ml.get('device')] = device_name_tmp;
					// report[this.ml.get("tag")]			= rpt.tag;
					report[this.ml.get("probability")] = rpt.prob ? parseInt(parseFloat(rpt.prob) * 100) + '%' : '';
					report[this.ml.get("user")] = rpt.user_trained ? rpt.user_trained.userName : "";
					report[this.ml.get("list")] = rpt.list;

					const date_hour = this.momentz(parseInt(rpt.unix_itme_stamp, 10)).format("YYYY-MM-DD_HH:mm ss").split("_");
					report[this.ml.get('date')] = date_hour[0];
					report[this.ml.get('hour')] = date_hour[1];

				}
				if (ref != "alarms") {

					const { ip, protocol, ext, base, domain } = this.API;
					let url = protocol;
					if (!ext) {
						url += domain;
					} else {
						url += `${ip}${base}`;
					}
					const link = `${url}/evidence_info/${ref}/${rpt.id}`;
					report[this.ml.get('evidence_link')] = { l: { Target: link }, v: link };
				}
				list.push(report);
			}// if check report
			if (cont == 500) {
				// console.log("cont timer ", cont)
				const timer = setTimeout(() => {
					cont = 0;
					this.report_export_excel(ref, items, device_name, Formats, load, list, cont);
					clearTimeout(timer)
				}, 100)
			} else {
				cont++;
				this.report_export_excel(ref, items, device_name, Formats, load, list, cont);
				// console.log("cont ", cont)
			}
			// }// for 
		} else {
			if (list && list.length > 0) {
				// console.log("Return list load ")
				load(list);
				load = null;
			} else {
				load([]);
				load = null;

			}
		}
	} // report_export_excel

	create_workbook_excel() {
		// This method will be updated to use lazy loading
		return null; // Will be implemented in the async version
	}

	async create_workbook_excel_async() {
		const { utils } = await this.loadXLSX();
		return utils.book_new();
	}

	add_sheet_for_excel(workbook, nameSheet, list) {
		// This method will be updated to use lazy loading
		console.warn('add_sheet_for_excel should be called with async version');
	}

	async add_sheet_for_excel_async(workbook, nameSheet, list) {
		const { utils } = await this.loadXLSX();
		const data = utils.json_to_sheet(list)
		console.log("DATA sheet ", data, nameSheet, list)
		console.time()
		utils.book_append_sheet(workbook, data, nameSheet);
		console.timeEnd()
	}

	download_excel(workbook, type) {
		// This method will be updated to use lazy loading
		console.warn('download_excel should be called with async version');
	}

	async download_excel_async(workbook, type) {
		const { writeFile } = await this.loadXLSX();
		let date = this.format_date(new Date(), "createdAt", "YYYY-MM-DD HH:mm ss");
		if (date) {
			date = date.split(" ").join("_");
		}
		const filename = `${date}_${type}`;
		writeFile(workbook, `${filename}.xlsx`)
	}

	export_excel(list, type = "events") {
		// This method will be updated to use lazy loading
		console.warn('export_excel should be called with async version');
	}

	async export_excel_async(list, type = "events") {
		const { utils, writeFile } = await this.loadXLSX();
		let date = this.format_date(new Date(), "createdAt", "YYYY-MM-DD HH:mm ss");
		if (date) {
			date = date.split(" ").join("_");
		}
		let data = utils.json_to_sheet(list)//dataToExport
		const workbook = utils.book_new();
		// console.log("DATA ",XLSX.utils, data)
		// create style hiperlink      	
		// const linkStyle = { font: { color: { rgb: '0563C1' }, underline: true } };
		/*	const headerStyle = {
				fill: {
				  fgColor: { rgb: 'FFFF00' }, // Amarillo (FF es la representación hexadecimal del color amarillo)
				},
				font: {
				  color: { rgb: '000000' }, // Color del texto (negro)
				  bold: true, // Texto en negrita
				},
			  };*/
		// data["A1"].s = headerStyle;	
		/*for (let col = XLSX.utils.decode_col('A'); col <= XLSX.utils.decode_col('H'); col++) {
				const cell = XLSX.utils.encode_cell({ c: col, r: 0 }); // Celda en la primera fila (encabezados)
				data[cell].s = headerStyle; // Aplicar el estilo a la celda
		}*/

		// data['H1'].s = headerStyle;
		// data['H1'].v = XLSX.utils.format_cell(data['H1'], 'General');

		const filename = `${date}_${type}`; //devschile-admins //  +  // 'Reports'      	
		utils.book_append_sheet(workbook, data, filename)
		writeFile(workbook, `${filename}.xlsx`)
	}

	async b64(url) {
		return new Promise((resolve, reject) => {
			const img = new Image();
			img.setAttribute('crossOrigin', 'anonymous');
			img.src = url;
			img.onload = () => {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				canvas.width = img.width;
				canvas.height = img.height;
				ctx.drawImage(img, 0, 0);
				const dataURL = canvas.toDataURL('image/png');
				resolve(dataURL);
			};
			img.onerror = (error) => {
				reject(error);
			};
		});
	}

	async test_excel() { // no funcional

		// this.hola()
		// Crear un nuevo libro de trabajo y una hoja de cálculo
		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet('Hoja1');


		const imageBase64 = await this.b64('http://193.178.3.128:9090//face/2023/6/25/1687716678685/1687716678407_YAhPn_2_cutted_face_photo.jpg')
		// Agregar una imagen
		const imageId = workbook.addImage({
			base64: imageBase64,
			extension: 'png',
		});

		worksheet.addImage(imageId, {
			tl: { col: 1, row: 2 }, // Coordenadas de la celda donde se insertará la imagen
			ext: { width: 60, height: 50 }, // Ancho y alto de la imagen
		});

		// Agregar hipervínculos
		// worksheet.getCell('B2').hyperlink = {
		//   ref: 'https://www.ejemplo.com', // Reemplaza con la URL proporcionada por el usuario
		//   tooltip: 'Haga clic para visitar el sitio web', // Texto de información sobre herramientas (tooltip)
		// };

		// Guardar el libro de trabajo en un archivo
		workbook.xlsx.writeBuffer().then((data) => {
			const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = 'archivo.xlsx';
			a.click();
		});

	}


} // close class

export default Format;

